// @ts-nocheck
 import { api } from "../customBaseQuery";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAccounts: build.query<GetAccountsApiResponse, GetAccountsApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/accounts`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createAccount: build.mutation<
      CreateAccountApiResponse,
      CreateAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/accounts`,
        method: "POST",
        body: queryArg.accountDto,
      }),
    }),
    updateAccount: build.mutation<
      UpdateAccountApiResponse,
      UpdateAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/accounts/${queryArg.accountId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    createAccountTransfer: build.mutation<
      CreateAccountTransferApiResponse,
      CreateAccountTransferApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/accounts/transfer`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getCommodities: build.query<
      GetCommoditiesApiResponse,
      GetCommoditiesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
          fromKey: queryArg.fromKey,
        },
      }),
    }),
    createCommodity: build.mutation<
      CreateCommodityApiResponse,
      CreateCommodityApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities`,
        method: "POST",
        body: queryArg.commodity,
      }),
    }),
    putCommodity: build.mutation<PutCommodityApiResponse, PutCommodityApiArg>({
      query: (queryArg) => ({
        url: `/core-api/commodities`,
        method: "PUT",
        body: queryArg.commodity,
      }),
    }),
    getCsv: build.query<GetCsvApiResponse, GetCsvApiArg>({
      query: () => ({ url: `/core-api/commodities/price-sheets/download` }),
    }),
    postCsv: build.mutation<PostCsvApiResponse, PostCsvApiArg>({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets/upload`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getPriceSheetCsvMulti: build.query<
      GetPriceSheetCsvMultiApiResponse,
      GetPriceSheetCsvMultiApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets/csv`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    putPriceSheetCsvMulti: build.mutation<
      PutPriceSheetCsvMultiApiResponse,
      PutPriceSheetCsvMultiApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets/csv`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getPriceSheetCsv2: build.query<
      GetPriceSheetCsv2ApiResponse,
      GetPriceSheetCsv2ApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets/${queryArg.priceSheetId}/csv`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    putPriceSheetCsv2: build.mutation<
      PutPriceSheetCsv2ApiResponse,
      PutPriceSheetCsv2ApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets/${queryArg.priceSheetId}/csv`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getCommodity: build.query<GetCommodityApiResponse, GetCommodityApiArg>({
      query: (queryArg) => ({
        url: `/core-api/commodities/${queryArg.commodityId}`,
      }),
    }),
    updateCommodity: build.mutation<
      UpdateCommodityApiResponse,
      UpdateCommodityApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/${queryArg.commodityId}`,
        method: "PUT",
        body: queryArg.commodity,
      }),
    }),
    getCustomers: build.query<GetCustomersApiResponse, GetCustomersApiArg>({
      query: (queryArg) => ({
        url: `/core-api/customers`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createCustomer: build.mutation<
      CreateCustomerApiResponse,
      CreateCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers`,
        method: "POST",
        body: queryArg.customer,
      }),
    }),
    getCustomerInvoices: build.query<
      GetCustomerInvoicesApiResponse,
      GetCustomerInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/${queryArg.customerId}/invoices`,
      }),
    }),
    getCustomer: build.query<GetCustomerApiResponse, GetCustomerApiArg>({
      query: (queryArg) => ({
        url: `/core-api/customers/${queryArg.customerId}`,
      }),
    }),
    updateCustomer: build.mutation<
      UpdateCustomerApiResponse,
      UpdateCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/${queryArg.customerId}`,
        method: "PUT",
        body: queryArg.customer,
      }),
    }),
    patchCustomer: build.mutation<
      PatchCustomerApiResponse,
      PatchCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/${queryArg.customerId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    archiveCustomer: build.mutation<
      ArchiveCustomerApiResponse,
      ArchiveCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/${queryArg.customerId}`,
        method: "DELETE",
      }),
    }),
    deleteCustomerLocation: build.mutation<
      DeleteCustomerLocationApiResponse,
      DeleteCustomerLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/${queryArg.customerId}/locations/${queryArg.locationId}`,
        method: "DELETE",
      }),
    }),
    checkBuyEligibility: build.mutation<
      CheckBuyEligibilityApiResponse,
      CheckBuyEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/compliance/buy-eligibility`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getGsUserList: build.query<GetGsUserListApiResponse, GetGsUserListApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/gs-users`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createGsUser: build.mutation<CreateGsUserApiResponse, CreateGsUserApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/gs-users`,
        method: "POST",
        body: queryArg.createGsUserRequestBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getGsUser: build.query<GetGsUserApiResponse, GetGsUserApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/gs-users/${queryArg.userId}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    updateGsUser: build.mutation<UpdateGsUserApiResponse, UpdateGsUserApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/gs-users/${queryArg.userId}`,
        method: "PATCH",
        body: queryArg.updateGsUserRequestBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    resetGsUserPassword: build.mutation<
      ResetGsUserPasswordApiResponse,
      ResetGsUserPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/gs-users/${queryArg.userId}/reset-password`,
        method: "POST",
        body: queryArg.resetUserPasswordRequestBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getTexasCashCard: build.query<
      GetTexasCashCardApiResponse,
      GetTexasCashCardApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/texas-cash-card/${queryArg.contactId}`,
      }),
    }),
    createTexasCashCard: build.mutation<
      CreateTexasCashCardApiResponse,
      CreateTexasCashCardApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/texas-cash-card`,
        method: "POST",
        body: queryArg.texasCashCardRequestDto,
      }),
    }),
    inviteContactToPortal: build.mutation<
      InviteContactToPortalApiResponse,
      InviteContactToPortalApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/portal-user/invite/${queryArg.contactId}`,
        method: "POST",
        body: queryArg.gsPortalUserRequestBody,
      }),
    }),
    getSupplierTypes: build.query<
      GetSupplierTypesApiResponse,
      GetSupplierTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/supplier-types`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createSupplierType: build.mutation<
      CreateSupplierTypeApiResponse,
      CreateSupplierTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/supplier-types`,
        method: "POST",
        body: queryArg.supplierType,
      }),
    }),
    patchSupplierType: build.mutation<
      PatchSupplierTypeApiResponse,
      PatchSupplierTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/supplier-types/${queryArg.supplierTypeId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getVendorClasses: build.query<
      GetVendorClassesApiResponse,
      GetVendorClassesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/vendor-classes`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createVendorClass: build.mutation<
      CreateVendorClassApiResponse,
      CreateVendorClassApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/vendor-classes`,
        method: "POST",
        body: queryArg.vendorClass,
      }),
    }),
    patchVendorClass: build.mutation<
      PatchVendorClassApiResponse,
      PatchVendorClassApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/vendor-classes/${queryArg.vendorClassId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getCustomerMaterialPurchasePriceHistory: build.query<
      GetCustomerMaterialPurchasePriceHistoryApiResponse,
      GetCustomerMaterialPurchasePriceHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/${queryArg.customerId}/purchase-price-history/${queryArg.materialTypeId}`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    getFinishedGoods: build.query<
      GetFinishedGoodsApiResponse,
      GetFinishedGoodsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/finished-goods`,
        params: {
          status: queryArg.status,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
          fromKey: queryArg.fromKey,
        },
      }),
    }),
    createFinishedGood: build.mutation<
      CreateFinishedGoodApiResponse,
      CreateFinishedGoodApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/finished-goods`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getFinishedGoodById: build.query<
      GetFinishedGoodByIdApiResponse,
      GetFinishedGoodByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/finished-goods/${queryArg.id}`,
      }),
    }),
    updateFinishedGood: build.mutation<
      UpdateFinishedGoodApiResponse,
      UpdateFinishedGoodApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/finished-goods/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    voidFinishedGood: build.mutation<
      VoidFinishedGoodApiResponse,
      VoidFinishedGoodApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/finished-goods/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getFinishedGoodByTag: build.query<
      GetFinishedGoodByTagApiResponse,
      GetFinishedGoodByTagApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/finished-goods/tag/${queryArg.tag}`,
      }),
    }),
    getInboundTickets: build.query<
      GetInboundTicketsApiResponse,
      GetInboundTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets`,
        params: {
          fromKey: queryArg.fromKey,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createInboundTicket: build.mutation<
      CreateInboundTicketApiResponse,
      CreateInboundTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets`,
        method: "POST",
        body: queryArg.inboundTicketSave,
      }),
    }),
    getInboundTicketsByIds: build.mutation<
      GetInboundTicketsByIdsApiResponse,
      GetInboundTicketsByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/by-ids`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getInboundTicketNotes: build.query<
      GetInboundTicketNotesApiResponse,
      GetInboundTicketNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/${queryArg.inboundTicketId}/notes`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    updateInboundTicketNotes: build.mutation<
      UpdateInboundTicketNotesApiResponse,
      UpdateInboundTicketNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/${queryArg.inboundTicketId}/notes`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    createInboundTicketNote: build.mutation<
      CreateInboundTicketNoteApiResponse,
      CreateInboundTicketNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/${queryArg.inboundTicketId}/notes`,
        method: "POST",
        body: queryArg.body,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    deleteInboundTicketNote: build.mutation<
      DeleteInboundTicketNoteApiResponse,
      DeleteInboundTicketNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/${queryArg.inboundTicketId}/notes/${queryArg.ibtNoteId}`,
        method: "DELETE",
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getInboundTicket: build.query<
      GetInboundTicketApiResponse,
      GetInboundTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/${queryArg.ticketId}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    updateInboundTicket: build.mutation<
      UpdateInboundTicketApiResponse,
      UpdateInboundTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/${queryArg.ticketId}`,
        method: "PUT",
        body: queryArg.inboundTicketSave,
      }),
    }),
    voidInboundTicket: build.mutation<
      VoidInboundTicketApiResponse,
      VoidInboundTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/${queryArg.ticketId}`,
        method: "DELETE",
      }),
    }),
    getInboundTicketQueuePayments: build.query<
      GetInboundTicketQueuePaymentsApiResponse,
      GetInboundTicketQueuePaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/queue-ticket-payments/${queryArg.inboundTicketId}`,
      }),
    }),
    getTexasXmlUploadFile: build.query<
      GetTexasXmlUploadFileApiResponse,
      GetTexasXmlUploadFileApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/xml`,
        params: { filter: queryArg.filter },
      }),
    }),
    getMaterialTypes: build.query<
      GetMaterialTypesApiResponse,
      GetMaterialTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/material-types`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
          fromKey: queryArg.fromKey,
        },
      }),
    }),
    createMaterialType: build.mutation<
      CreateMaterialTypeApiResponse,
      CreateMaterialTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/material-types`,
        method: "POST",
        body: queryArg.materialType,
      }),
    }),
    getMaterialType: build.query<
      GetMaterialTypeApiResponse,
      GetMaterialTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/material-types/${queryArg.materialTypeId}`,
        params: { filter: queryArg.filter },
      }),
    }),
    patchMaterialType: build.mutation<
      PatchMaterialTypeApiResponse,
      PatchMaterialTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/material-types/${queryArg.materialTypeId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    archiveMaterialType: build.mutation<
      ArchiveMaterialTypeApiResponse,
      ArchiveMaterialTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/material-types/${queryArg.materialTypeId}`,
        method: "DELETE",
      }),
    }),
    getMaterials: build.query<GetMaterialsApiResponse, GetMaterialsApiArg>({
      query: (queryArg) => ({
        url: `/core-api/materials`,
        params: {
          fromKey: queryArg.fromKey,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createMaterial: build.mutation<
      CreateMaterialApiResponse,
      CreateMaterialApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/materials`,
        method: "POST",
        body: queryArg.materialSave,
      }),
    }),
    getMaterial: build.query<GetMaterialApiResponse, GetMaterialApiArg>({
      query: (queryArg) => ({
        url: `/core-api/materials/${queryArg.materialId}`,
      }),
    }),
    updateMaterial: build.mutation<
      UpdateMaterialApiResponse,
      UpdateMaterialApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/materials/${queryArg.materialId}`,
        method: "PUT",
        body: queryArg.materialSave,
      }),
    }),
    getOutboundTicket: build.query<
      GetOutboundTicketApiResponse,
      GetOutboundTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/outbound-tickets/${queryArg.outboundTicketId}`,
      }),
    }),
    updateOutboundTicket: build.mutation<
      UpdateOutboundTicketApiResponse,
      UpdateOutboundTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/outbound-tickets/${queryArg.outboundTicketId}`,
        method: "PUT",
        body: queryArg.outboundTicketRequestDto,
      }),
    }),
    voidOutboundTicket: build.mutation<
      VoidOutboundTicketApiResponse,
      VoidOutboundTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/outbound-tickets/${queryArg.outboundTicketId}`,
        method: "DELETE",
      }),
    }),
    getOutboundTickets: build.query<
      GetOutboundTicketsApiResponse,
      GetOutboundTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/outbound-tickets`,
        params: {
          fromKey: queryArg.fromKey,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createOutboundTicket: build.mutation<
      CreateOutboundTicketApiResponse,
      CreateOutboundTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/outbound-tickets`,
        method: "POST",
        body: queryArg.outboundTicketRequestDto,
      }),
    }),
    getOutboundTicketsByIds: build.mutation<
      GetOutboundTicketsByIdsApiResponse,
      GetOutboundTicketsByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/outbound-tickets/by-ids`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getPackingLists: build.query<
      GetPackingListsApiResponse,
      GetPackingListsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/packing-lists`,
        params: {
          filter: queryArg.filter,
          sortDescending: queryArg.sortDescending,
        },
      }),
    }),
    createPackingList: build.mutation<
      CreatePackingListApiResponse,
      CreatePackingListApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/packing-lists`,
        method: "POST",
        body: queryArg.packingListRequestDto,
      }),
    }),
    getPackingListById: build.query<
      GetPackingListByIdApiResponse,
      GetPackingListByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/packing-lists/${queryArg.packingListId}`,
      }),
    }),
    updatePackingList: build.mutation<
      UpdatePackingListApiResponse,
      UpdatePackingListApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/packing-lists/${queryArg.packingListId}`,
        method: "PUT",
        body: queryArg.packingList,
      }),
    }),
    voidPackingList: build.mutation<
      VoidPackingListApiResponse,
      VoidPackingListApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/packing-lists/${queryArg.packingListId}`,
        method: "DELETE",
      }),
    }),
    getInventoryAdjustments: build.query<
      GetInventoryAdjustmentsApiResponse,
      GetInventoryAdjustmentsApiArg
    >({
      query: () => ({ url: `/core-api/inventory/adjustment` }),
    }),
    createInventoryAdjustment: build.mutation<
      CreateInventoryAdjustmentApiResponse,
      CreateInventoryAdjustmentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/adjustment`,
        method: "POST",
        body: queryArg.inventoryAdjustment,
      }),
    }),
    getInventoryAdjustment: build.query<
      GetInventoryAdjustmentApiResponse,
      GetInventoryAdjustmentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/adjustment/${queryArg.id}`,
      }),
    }),
    updateInventoryAdjustment: build.mutation<
      UpdateInventoryAdjustmentApiResponse,
      UpdateInventoryAdjustmentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/adjustment/${queryArg.id}`,
        method: "PUT",
        body: queryArg.inventoryAdjustment,
      }),
    }),
    deleteInventoryAdjustment: build.mutation<
      DeleteInventoryAdjustmentApiResponse,
      DeleteInventoryAdjustmentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/adjustment/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getPriceSheets: build.query<
      GetPriceSheetsApiResponse,
      GetPriceSheetsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
          fromKey: queryArg.fromKey,
        },
      }),
    }),
    createPriceSheet: build.mutation<
      CreatePriceSheetApiResponse,
      CreatePriceSheetApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets`,
        method: "POST",
        body: queryArg.priceSheet,
      }),
    }),
    getDefaultPriceSheet: build.query<
      GetDefaultPriceSheetApiResponse,
      GetDefaultPriceSheetApiArg
    >({
      query: () => ({ url: `/core-api/commodities/price-sheets/default` }),
    }),
    getPriceSheet: build.query<GetPriceSheetApiResponse, GetPriceSheetApiArg>({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets/${queryArg.priceSheetId}`,
        params: { filter: queryArg.filter },
      }),
    }),
    updatePriceSheet: build.mutation<
      UpdatePriceSheetApiResponse,
      UpdatePriceSheetApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets/${queryArg.priceSheetId}`,
        method: "PUT",
        body: queryArg.priceSheet,
      }),
    }),
    archivePriceSheet: build.mutation<
      ArchivePriceSheetApiResponse,
      ArchivePriceSheetApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-sheets/${queryArg.priceListId}/archive`,
        method: "PUT",
      }),
    }),
    deletePriceEntry: build.mutation<
      DeletePriceEntryApiResponse,
      DeletePriceEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-entries/price-sheet/${queryArg.priceSheetId}/material-type/${queryArg.materialTypeId}`,
        method: "DELETE",
      }),
    }),
    getPriceSheetCsv: build.query<
      GetPriceSheetCsvApiResponse,
      GetPriceSheetCsvApiArg
    >({
      query: () => ({ url: `/core-api/pricesheets/batch` }),
    }),
    uploadNewPriceSheets: build.mutation<
      UploadNewPriceSheetsApiResponse,
      UploadNewPriceSheetsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/pricesheets/batch`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    uploadUpdatePriceSheets: build.mutation<
      UploadUpdatePriceSheetsApiResponse,
      UploadUpdatePriceSheetsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/pricesheets/batch`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    mergeInboundTickets: build.mutation<
      MergeInboundTicketsApiResponse,
      MergeInboundTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/inbound-tickets/${queryArg.id}/merge`,
        method: "PUT",
        body: queryArg.mergeIbtsRequest,
      }),
    }),
    getRegrades: build.query<GetRegradesApiResponse, GetRegradesApiArg>({
      query: (queryArg) => ({
        url: `/core-api/inventory/regrades`,
        params: {
          archive: queryArg.archive,
          sortDescending: queryArg.sortDescending,
        },
      }),
    }),
    createRegrade: build.mutation<
      CreateRegradeApiResponse,
      CreateRegradeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/regrades`,
        method: "POST",
        body: queryArg.regradeDto,
      }),
    }),
    getRegradeById: build.query<
      GetRegradeByIdApiResponse,
      GetRegradeByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/regrades/${queryArg.regradeId}`,
      }),
    }),
    updateRegrade: build.mutation<
      UpdateRegradeApiResponse,
      UpdateRegradeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/regrades/${queryArg.regradeId}`,
        method: "PUT",
        body: queryArg.regradeDto,
      }),
    }),
    voidRegrade: build.mutation<VoidRegradeApiResponse, VoidRegradeApiArg>({
      query: (queryArg) => ({
        url: `/core-api/inventory/regrades/${queryArg.regradeId}`,
        method: "DELETE",
      }),
    }),
    getInventoryCommodityHandler: build.query<
      GetInventoryCommodityHandlerApiResponse,
      GetInventoryCommodityHandlerApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/commodity`,
        params: {
          fromKey: queryArg.fromKey,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    getInventoryByCommodity: build.query<
      GetInventoryByCommodityApiResponse,
      GetInventoryByCommodityApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/commodity/${queryArg.commodityId}`,
      }),
    }),
    getInventoryFinishedGoodList: build.query<
      GetInventoryFinishedGoodListApiResponse,
      GetInventoryFinishedGoodListApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/finished-goods`,
        params: {
          fromKey: queryArg.fromKey,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    getInventoryRegradeMeta: build.query<
      GetInventoryRegradeMetaApiResponse,
      GetInventoryRegradeMetaApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/regrades/meta`,
        params: { filter: queryArg.filter },
      }),
    }),
    getInventoryPackingListMeta: build.query<
      GetInventoryPackingListMetaApiResponse,
      GetInventoryPackingListMetaApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/packing-lists/meta`,
        params: { filter: queryArg.filter },
      }),
    }),
    getInventoryMaterialType: build.query<
      GetInventoryMaterialTypeApiResponse,
      GetInventoryMaterialTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/material-types/${queryArg.materialTypeId}`,
        params: { filter: queryArg.filter },
      }),
    }),
    getInventoryMaterialTypeByIds: build.mutation<
      GetInventoryMaterialTypeByIdsApiResponse,
      GetInventoryMaterialTypeByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/material-types/by-ids`,
        method: "POST",
        body: queryArg.body,
        params: { filter: queryArg.filter },
      }),
    }),
    getNegativeInventoryList: build.query<
      GetNegativeInventoryListApiResponse,
      GetNegativeInventoryListApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/inventory/negative`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getOrganization: build.query<
      GetOrganizationApiResponse,
      GetOrganizationApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/organization`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getBenchmarks: build.query<GetBenchmarksApiResponse, GetBenchmarksApiArg>({
      query: (queryArg) => ({
        url: `/core-api/commodities/benchmarks`,
        params: {
          fromKey: queryArg.fromKey,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createBenchmark: build.mutation<
      CreateBenchmarkApiResponse,
      CreateBenchmarkApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/benchmarks`,
        method: "POST",
        body: queryArg.benchmark,
      }),
    }),
    getBenchmarkById: build.query<
      GetBenchmarkByIdApiResponse,
      GetBenchmarkByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/benchmarks/${queryArg.benchmarkId}`,
      }),
    }),
    updateBenchmark: build.mutation<
      UpdateBenchmarkApiResponse,
      UpdateBenchmarkApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/benchmarks/${queryArg.benchmarkId}`,
        method: "PUT",
        body: queryArg.benchmark,
      }),
    }),
    getPriceEntries: build.query<
      GetPriceEntriesApiResponse,
      GetPriceEntriesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-entries`,
        params: {
          fromKey: queryArg.fromKey,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createPriceEntry: build.mutation<
      CreatePriceEntryApiResponse,
      CreatePriceEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-entries`,
        method: "POST",
        body: queryArg.priceEntry,
      }),
    }),
    getPriceEntry: build.query<GetPriceEntryApiResponse, GetPriceEntryApiArg>({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-entries/${queryArg.priceEntryId}`,
      }),
    }),
    updatePriceEntry: build.mutation<
      UpdatePriceEntryApiResponse,
      UpdatePriceEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/price-entries/${queryArg.priceEntryId}`,
        method: "PUT",
        body: queryArg.priceEntry,
      }),
    }),
    getPriceEntryHistoryByMaterialId: build.query<
      GetPriceEntryHistoryByMaterialIdApiResponse,
      GetPriceEntryHistoryByMaterialIdApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/material-types/${queryArg.materialTypeId}/price-entries/history`,
      }),
    }),
    getSalesOrders: build.query<
      GetSalesOrdersApiResponse,
      GetSalesOrdersApiArg
    >({
      query: () => ({ url: `/core-api/contracts/sales-orders` }),
    }),
    createSalesOrder: build.mutation<
      CreateSalesOrderApiResponse,
      CreateSalesOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/sales-orders`,
        method: "POST",
        body: queryArg.salesOrderCreation,
      }),
    }),
    getSalesOrder: build.query<GetSalesOrderApiResponse, GetSalesOrderApiArg>({
      query: (queryArg) => ({
        url: `/core-api/contracts/sales-orders/${queryArg.salesOrderId}`,
      }),
    }),
    updateSalesOrder: build.mutation<
      UpdateSalesOrderApiResponse,
      UpdateSalesOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/sales-orders/${queryArg.salesOrderId}`,
        method: "PUT",
        body: queryArg.salesOrder,
      }),
    }),
    archiveSalesOrder: build.mutation<
      ArchiveSalesOrderApiResponse,
      ArchiveSalesOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/sales-orders/${queryArg.salesOrderId}/archive`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getSalesOrdersCsv: build.query<
      GetSalesOrdersCsvApiResponse,
      GetSalesOrdersCsvApiArg
    >({
      query: () => ({ url: `/core-api/contracts/sales-orders/csv` }),
    }),
    uploadSalesOrdersCsv: build.mutation<
      UploadSalesOrdersCsvApiResponse,
      UploadSalesOrdersCsvApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/sales-orders/csv`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getPurchaseOrdersV2: build.query<
      GetPurchaseOrdersV2ApiResponse,
      GetPurchaseOrdersV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/v2/purchase-orders`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    getPurchaseOrders: build.query<
      GetPurchaseOrdersApiResponse,
      GetPurchaseOrdersApiArg
    >({
      query: () => ({ url: `/core-api/contracts/purchase-orders` }),
    }),
    createPurchaseOrder: build.mutation<
      CreatePurchaseOrderApiResponse,
      CreatePurchaseOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/purchase-orders`,
        method: "POST",
        body: queryArg.purchaseOrderCreation,
      }),
    }),
    archivePurchaseOrder: build.mutation<
      ArchivePurchaseOrderApiResponse,
      ArchivePurchaseOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/purchase-orders/${queryArg.purchaseOrderId}/archive`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getPurchaseOrder: build.query<
      GetPurchaseOrderApiResponse,
      GetPurchaseOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/purchase-orders/${queryArg.purchaseOrderId}`,
      }),
    }),
    updatePurchaseOrder: build.mutation<
      UpdatePurchaseOrderApiResponse,
      UpdatePurchaseOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/purchase-orders/${queryArg.purchaseOrderId}`,
        method: "PUT",
        body: queryArg.purchaseOrder,
      }),
    }),
    getPurchaseOrdersCsv: build.query<
      GetPurchaseOrdersCsvApiResponse,
      GetPurchaseOrdersCsvApiArg
    >({
      query: () => ({ url: `/core-api/contracts/purchase-orders/csv` }),
    }),
    uploadPurchaseOrdersCsv: build.mutation<
      UploadPurchaseOrdersCsvApiResponse,
      UploadPurchaseOrdersCsvApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/contracts/purchase-orders/csv`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteInvoiceBulkPayment: build.mutation<
      DeleteInvoiceBulkPaymentApiResponse,
      DeleteInvoiceBulkPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/payments/${queryArg.paymentId}`,
        method: "DELETE",
      }),
    }),
    createInvoiceBulkPayment: build.mutation<
      CreateInvoiceBulkPaymentApiResponse,
      CreateInvoiceBulkPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/payments`,
        method: "POST",
        body: queryArg.invoiceBulkPaymentCreation,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getInvoicePayments: build.query<
      GetInvoicePaymentsApiResponse,
      GetInvoicePaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/invoice-payments`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    getInvoicesV2: build.query<GetInvoicesV2ApiResponse, GetInvoicesV2ApiArg>({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/v2`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createInvoiceV2: build.mutation<
      CreateInvoiceV2ApiResponse,
      CreateInvoiceV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/v2`,
        method: "POST",
        body: queryArg.invoiceRequestBody,
      }),
    }),
    createInboundInvoiceV2: build.mutation<
      CreateInboundInvoiceV2ApiResponse,
      CreateInboundInvoiceV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/v2/inbound`,
        method: "POST",
        body: queryArg.invoiceInboundRequestBody,
      }),
    }),
    updateInboundInvoiceV2: build.mutation<
      UpdateInboundInvoiceV2ApiResponse,
      UpdateInboundInvoiceV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/v2/${queryArg.invoiceId}/inbound`,
        method: "PUT",
        body: queryArg.invoiceInboundRequestBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getInvoicePayment: build.query<
      GetInvoicePaymentApiResponse,
      GetInvoicePaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/invoice-payments/${queryArg.paymentId}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getInvoiceV2: build.query<GetInvoiceV2ApiResponse, GetInvoiceV2ApiArg>({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/v2/${queryArg.invoiceId}`,
      }),
    }),
    updateInvoiceV2: build.mutation<
      UpdateInvoiceV2ApiResponse,
      UpdateInvoiceV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/v2/${queryArg.invoiceId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getInvoiceV3: build.query<GetInvoiceV3ApiResponse, GetInvoiceV3ApiArg>({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/v3/${queryArg.invoiceId}`,
      }),
    }),
    voidInvoice: build.mutation<VoidInvoiceApiResponse, VoidInvoiceApiArg>({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/${queryArg.invoiceId}/void`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getDevices: build.query<GetDevicesApiResponse, GetDevicesApiArg>({
      query: (queryArg) => ({
        url: `/core-api/iot/devices`,
        params: { filter: queryArg.filter },
      }),
    }),
    captureImage: build.mutation<CaptureImageApiResponse, CaptureImageApiArg>({
      query: (queryArg) => ({
        url: `/core-api/iot/devices/${queryArg.deviceId}/image`,
        method: "POST",
        params: { filename: queryArg.filename },
      }),
    }),
    createQzTraySignature: build.mutation<
      CreateQzTraySignatureApiResponse,
      CreateQzTraySignatureApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/iot/qz-tray/sign`,
        method: "POST",
        body: queryArg.body,
        headers: { yard: queryArg.yard, organization: queryArg.organization },
      }),
    }),
    getOrgImage: build.query<GetOrgImageApiResponse, GetOrgImageApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/assets/yard-images/${queryArg.filename}`,
        params: { isTemp: queryArg.isTemp, expiresIn: queryArg.expiresIn },
      }),
    }),
    uploadOrgImage: build.mutation<
      UploadOrgImageApiResponse,
      UploadOrgImageApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/assets/yard-images`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getBills: build.query<GetBillsApiResponse, GetBillsApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/bills`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    getBill: build.query<GetBillApiResponse, GetBillApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/bills/${queryArg.billId}`,
      }),
    }),
    updateBill: build.mutation<UpdateBillApiResponse, UpdateBillApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/bills/${queryArg.billId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    mergeBill: build.mutation<MergeBillApiResponse, MergeBillApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/bills/${queryArg.billId}/merge`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    unmergeBill: build.mutation<UnmergeBillApiResponse, UnmergeBillApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/bills/${queryArg.billId}/unmerge`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    updateAndMergeBill: build.mutation<
      UpdateAndMergeBillApiResponse,
      UpdateAndMergeBillApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/bills/${queryArg.billId}/update-and-merge`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    voidBill: build.mutation<VoidBillApiResponse, VoidBillApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/bills/${queryArg.billId}/void`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getPayments: build.query<GetPaymentsApiResponse, GetPaymentsApiArg>({
      query: () => ({ url: `/core-api/purchases/payments` }),
    }),
    createPayment: build.mutation<
      CreatePaymentApiResponse,
      CreatePaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/payments`,
        method: "POST",
        body: queryArg.paymentCreation,
      }),
    }),
    getPayment: build.query<GetPaymentApiResponse, GetPaymentApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/payments/${queryArg.paymentId}`,
      }),
    }),
    updatePayment: build.mutation<
      UpdatePaymentApiResponse,
      UpdatePaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/purchases/payments/${queryArg.paymentId}`,
        method: "PUT",
        body: queryArg.payment,
      }),
    }),
    voidPayment: build.mutation<VoidPaymentApiResponse, VoidPaymentApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/payments/${queryArg.paymentId}`,
        method: "DELETE",
      }),
    }),
    getItemsToSync: build.query<
      GetItemsToSyncApiResponse,
      GetItemsToSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/ledger/sync-eligible`,
        params: { syncStatus: queryArg.syncStatus },
      }),
    }),
    syncItems: build.mutation<SyncItemsApiResponse, SyncItemsApiArg>({
      query: (queryArg) => ({
        url: `/core-api/ledger/${queryArg.erpProvider}/data-sync`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getBatches: build.query<GetBatchesApiResponse, GetBatchesApiArg>({
      query: () => ({ url: `/core-api/ledger/batch` }),
    }),
    getBatch: build.query<GetBatchApiResponse, GetBatchApiArg>({
      query: (queryArg) => ({
        url: `/core-api/ledger/batch/${queryArg.batchId}`,
      }),
    }),
    markItemsAsCompleted: build.mutation<
      MarkItemsAsCompletedApiResponse,
      MarkItemsAsCompletedApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/ledger/sync-status`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    sendEmail: build.mutation<SendEmailApiResponse, SendEmailApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/email`,
        method: "POST",
        body: queryArg.body,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    sendOutboundTicketEmail: build.mutation<
      SendOutboundTicketEmailApiResponse,
      SendOutboundTicketEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/email/outbound-tickets`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getPermissions: build.query<
      GetPermissionsApiResponse,
      GetPermissionsApiArg
    >({
      query: () => ({ url: `/core-api/core/permissions` }),
    }),
    getLicenseInfo: build.mutation<
      GetLicenseInfoApiResponse,
      GetLicenseInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/external/license-info`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getVehicleInfoFromVin: build.query<
      GetVehicleInfoFromVinApiResponse,
      GetVehicleInfoFromVinApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/external/vin-decoder/${queryArg.vin}`,
      }),
    }),
    getPullApartScrapRows: build.query<
      GetPullApartScrapRowsApiResponse,
      GetPullApartScrapRowsApiArg
    >({
      query: () => ({
        url: `/core-api/core/external/pap/scrap/ListAvailableScrapRows`,
      }),
    }),
    getInvoicePaymentByInvoiceId: build.query<
      GetInvoicePaymentByInvoiceIdApiResponse,
      GetInvoicePaymentByInvoiceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/${queryArg.invoiceId}/payments`,
      }),
    }),
    createInvoicePayment: build.mutation<
      CreateInvoicePaymentApiResponse,
      CreateInvoicePaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/sales/invoices/${queryArg.invoiceId}/payments`,
        method: "POST",
        body: queryArg.invoicePaymentRequest,
      }),
    }),
    getYard: build.query<GetYardApiResponse, GetYardApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/yards/${queryArg.yardId}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    getSettings: build.query<GetSettingsApiResponse, GetSettingsApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/settings`,
        headers: { origin: queryArg.origin },
      }),
    }),
    postSettingsRbac: build.mutation<
      PostSettingsRbacApiResponse,
      PostSettingsRbacApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/settings/adminSettings/rbac`,
        method: "POST",
        body: queryArg.adminRbacSettings,
        headers: { yard: queryArg.yard, organization: queryArg.organization },
      }),
    }),
    getFpSettings: build.query<GetFpSettingsApiResponse, GetFpSettingsApiArg>({
      query: (queryArg) => ({
        url: `/core-api/core/settings/purchaseSettings/feesOrPromotions`,
        params: { filter: queryArg.filter },
      }),
    }),
    createFeeOrPromotionPreset: build.mutation<
      CreateFeeOrPromotionPresetApiResponse,
      CreateFeeOrPromotionPresetApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/settings/purchaseSettings/feesOrPromotions`,
        method: "POST",
        body: queryArg.feeOrPromotionSettingBody,
      }),
    }),
    updateFeeOrPromotionPreset: build.mutation<
      UpdateFeeOrPromotionPresetApiResponse,
      UpdateFeeOrPromotionPresetApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/settings/purchaseSettings/feesOrPromotions/${queryArg.feeOrPromotionId}`,
        method: "PUT",
        body: queryArg.updateFeeOrPromotionSettingBody,
      }),
    }),
    archiveFeeOrPromotionPreset: build.mutation<
      ArchiveFeeOrPromotionPresetApiResponse,
      ArchiveFeeOrPromotionPresetApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/settings/purchaseSettings/feesOrPromotions/${queryArg.feeOrPromotionId}`,
        method: "DELETE",
      }),
    }),
    updateSettings: build.mutation<
      UpdateSettingsApiResponse,
      UpdateSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/settings/${queryArg.category}/${queryArg.subCategory}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTransfers: build.query<GetTransfersApiResponse, GetTransfersApiArg>({
      query: () => ({ url: `/core-api/purchases/transfers` }),
    }),
    getTransfer: build.query<GetTransferApiResponse, GetTransferApiArg>({
      query: (queryArg) => ({
        url: `/core-api/purchases/transfers/${queryArg.transferId}`,
      }),
    }),
    getScaleReading: build.query<
      GetScaleReadingApiResponse,
      GetScaleReadingApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/iot/devices/${queryArg.deviceId}/scale-reading`,
      }),
    }),
    createVehicle: build.mutation<
      CreateVehicleApiResponse,
      CreateVehicleApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/vehicles`,
        method: "POST",
        body: queryArg.vehicle,
      }),
    }),
    getVehicles: build.query<GetVehiclesApiResponse, GetVehiclesApiArg>({
      query: (queryArg) => ({
        url: `/core-api/customers/vehicles`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    getVehicle: build.query<GetVehicleApiResponse, GetVehicleApiArg>({
      query: (queryArg) => ({
        url: `/core-api/customers/vehicles/${queryArg.vehicleId}`,
      }),
    }),
    updateVehicle: build.mutation<
      UpdateVehicleApiResponse,
      UpdateVehicleApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/customers/vehicles/${queryArg.vehicleId}`,
        method: "PUT",
        body: queryArg.vehicle,
      }),
    }),
    saveGsPayVendor: build.mutation<
      SaveGsPayVendorApiResponse,
      SaveGsPayVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/financial/gs-pay/vendor`,
        method: "POST",
        body: queryArg.saveGsPayVendorRequest,
      }),
    }),
    getFreightBills: build.query<
      GetFreightBillsApiResponse,
      GetFreightBillsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/financial/freight-bill`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    getBatchBills: build.query<GetBatchBillsApiResponse, GetBatchBillsApiArg>({
      query: (queryArg) => ({
        url: `/core-api/financial/batch-bill`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    createBatchBill: build.mutation<
      CreateBatchBillApiResponse,
      CreateBatchBillApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/financial/batch-bill`,
        method: "POST",
        body: queryArg.batchBillRequestBody,
      }),
    }),
    getBatchBill: build.query<GetBatchBillApiResponse, GetBatchBillApiArg>({
      query: (queryArg) => ({
        url: `/core-api/financial/batch-bill/${queryArg.batchBillId}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    updateBatchBill: build.mutation<
      UpdateBatchBillApiResponse,
      UpdateBatchBillApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/financial/batch-bill/${queryArg.batchBillId}`,
        method: "PUT",
        body: queryArg.batchBillRequestBody,
        headers: { billIds: queryArg.billIds },
      }),
    }),
    payBatchBill: build.mutation<PayBatchBillApiResponse, PayBatchBillApiArg>({
      query: (queryArg) => ({
        url: `/core-api/financial/batch-bill/${queryArg.batchBillId}/payment`,
        method: "POST",
        body: queryArg.body,
        headers: { billIds: queryArg.billIds },
      }),
    }),
    getVehicleMakeModels: build.query<
      GetVehicleMakeModelsApiResponse,
      GetVehicleMakeModelsApiArg
    >({
      query: () => ({ url: `/core-api/core/veh-make-model` }),
    }),
    getCurrencyConversions: build.query<
      GetCurrencyConversionsApiResponse,
      GetCurrencyConversionsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/foreign-exchanges`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    updateCurrencyConversions: build.mutation<
      UpdateCurrencyConversionsApiResponse,
      UpdateCurrencyConversionsApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/commodities/foreign-exchanges`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getLockAccountingPeriod: build.query<
      GetLockAccountingPeriodApiResponse,
      GetLockAccountingPeriodApiArg
    >({
      query: () => ({ url: `/core-api/core/lock-accounting-period` }),
    }),
    updateLockAccountingPeriod: build.mutation<
      UpdateLockAccountingPeriodApiResponse,
      UpdateLockAccountingPeriodApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/lock-accounting-period`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getLockedEntities: build.query<
      GetLockedEntitiesApiResponse,
      GetLockedEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/lock-accounting-period/entity-list`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    getFreightLanes: build.query<
      GetFreightLanesApiResponse,
      GetFreightLanesApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/freight-lanes`,
        params: { filter: queryArg.filter },
      }),
    }),
    createFreightLane: build.mutation<
      CreateFreightLaneApiResponse,
      CreateFreightLaneApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/freight-lanes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getFreightLane: build.query<
      GetFreightLaneApiResponse,
      GetFreightLaneApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/freight-lanes/${queryArg.id}`,
      }),
    }),
    updateFreightLane: build.mutation<
      UpdateFreightLaneApiResponse,
      UpdateFreightLaneApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/freight-lanes/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getFreightLaneLocations: build.query<
      GetFreightLaneLocationsApiResponse,
      GetFreightLaneLocationsApiArg
    >({
      query: () => ({ url: `/dispatch-api/core/freight-lanes/locations` }),
    }),
    createFreightLaneLocation: build.mutation<
      CreateFreightLaneLocationApiResponse,
      CreateFreightLaneLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/freight-lanes/locations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateFreightLaneLocation: build.mutation<
      UpdateFreightLaneLocationApiResponse,
      UpdateFreightLaneLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/freight-lanes/locations/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getFreightLanePrices: build.query<
      GetFreightLanePricesApiResponse,
      GetFreightLanePricesApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/freight-lanes/${queryArg.id}/prices`,
      }),
    }),
    updateFreightLanePrices: build.mutation<
      UpdateFreightLanePricesApiResponse,
      UpdateFreightLanePricesApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/freight-lanes/${queryArg.id}/prices`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getMetabaseUrl: build.query<
      GetMetabaseUrlApiResponse,
      GetMetabaseUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/reports/${queryArg.reportId}`,
        params: { customParams: queryArg.customParams },
      }),
    }),
    getPaymentTerms: build.query<
      GetPaymentTermsApiResponse,
      GetPaymentTermsApiArg
    >({
      query: () => ({ url: `/core-api/core/payment-terms` }),
    }),
    createPaymentTerm: build.mutation<
      CreatePaymentTermApiResponse,
      CreatePaymentTermApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/payment-terms`,
        method: "POST",
        body: queryArg.paymentTerm,
      }),
    }),
    patchPaymentTerm: build.mutation<
      PatchPaymentTermApiResponse,
      PatchPaymentTermApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/payment-terms/${queryArg.paymentTermId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deactivatePaymentTerm: build.mutation<
      DeactivatePaymentTermApiResponse,
      DeactivatePaymentTermApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/payment-terms/${queryArg.paymentTermId}`,
        method: "DELETE",
      }),
    }),
    getAssetsByCategory: build.query<
      GetAssetsByCategoryApiResponse,
      GetAssetsByCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    createPhysicalAsset: build.mutation<
      CreatePhysicalAssetApiResponse,
      CreatePhysicalAssetApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}`,
        method: "POST",
        body: queryArg.physicalAsset,
      }),
    }),
    getAssetByCategoryAndId: build.query<
      GetAssetByCategoryAndIdApiResponse,
      GetAssetByCategoryAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}/${queryArg.assetId}`,
      }),
    }),
    patchPhysicalAsset: build.mutation<
      PatchPhysicalAssetApiResponse,
      PatchPhysicalAssetApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}/${queryArg.assetId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getAssetTypes: build.query<GetAssetTypesApiResponse, GetAssetTypesApiArg>({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}/types`,
      }),
    }),
    createAssetTypes: build.mutation<
      CreateAssetTypesApiResponse,
      CreateAssetTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}/types`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateAssetTypes: build.mutation<
      UpdateAssetTypesApiResponse,
      UpdateAssetTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}/types/${queryArg.assetTypeId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getAssetHistory: build.query<
      GetAssetHistoryApiResponse,
      GetAssetHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}/${queryArg.assetId}/asset-statuses`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createAssetStatus: build.mutation<
      CreateAssetStatusApiResponse,
      CreateAssetStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/assets/${queryArg.assetCategory}/${queryArg.assetId}/asset-statuses`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getDispatchTickets: build.query<
      GetDispatchTicketsApiResponse,
      GetDispatchTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/dispatch-tickets`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
          sort: queryArg.sort,
        },
      }),
    }),
    createDispatchTicket: build.mutation<
      CreateDispatchTicketApiResponse,
      CreateDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/dispatch-tickets`,
        method: "POST",
        body: queryArg.createDispatchTicketBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    patchMultipleDispatchTickets: build.mutation<
      PatchMultipleDispatchTicketsApiResponse,
      PatchMultipleDispatchTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/dispatch-tickets`,
        method: "PATCH",
        body: queryArg.body,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getDispatchTicket: build.query<
      GetDispatchTicketApiResponse,
      GetDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/dispatch-tickets/${queryArg.dispatchTicketId}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    updateDispatchTicket: build.mutation<
      UpdateDispatchTicketApiResponse,
      UpdateDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/dispatch-tickets/${queryArg.dispatchTicketId}`,
        method: "PUT",
        body: queryArg.updateDispatchTicketBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    patchDispatchTicket: build.mutation<
      PatchDispatchTicketApiResponse,
      PatchDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/dispatch-tickets/${queryArg.dispatchTicketId}`,
        method: "PATCH",
        body: queryArg.patchDispatchTicketBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    voidDispatchTicket: build.mutation<
      VoidDispatchTicketApiResponse,
      VoidDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/dispatch-tickets/${queryArg.dispatchTicketId}`,
        method: "DELETE",
        body: queryArg.voidDispatchTicketBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getRecurringDispatchTickets: build.query<
      GetRecurringDispatchTicketsApiResponse,
      GetRecurringDispatchTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/recurring-dispatch-tickets`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    createRecurringDispatchTicket: build.mutation<
      CreateRecurringDispatchTicketApiResponse,
      CreateRecurringDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/recurring-dispatch-tickets`,
        method: "POST",
        body: queryArg.recurringDispatchTicketSchema,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getRecurringDispatchTicket: build.query<
      GetRecurringDispatchTicketApiResponse,
      GetRecurringDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/recurring-dispatch-tickets/${queryArg.recurringDispatchTicketId}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    updateRecurringDispatchTicket: build.mutation<
      UpdateRecurringDispatchTicketApiResponse,
      UpdateRecurringDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/recurring-dispatch-tickets/${queryArg.recurringDispatchTicketId}`,
        method: "PUT",
        body: queryArg.recurringDispatchTicketSchema,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    archiveRecurringDispatchTicket: build.mutation<
      ArchiveRecurringDispatchTicketApiResponse,
      ArchiveRecurringDispatchTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/recurring-dispatch-tickets/${queryArg.recurringDispatchTicketId}`,
        method: "DELETE",
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
        params: {
          dispatchTicketId: queryArg.dispatchTicketId,
          deleteDispatchTicket: queryArg.deleteDispatchTicket,
        },
      }),
    }),
    getDrivers: build.query<GetDriversApiResponse, GetDriversApiArg>({
      query: (queryArg) => ({
        url: `/dispatch-api/core/drivers/`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          filter: queryArg.filter,
        },
      }),
    }),
    createDriver: build.mutation<CreateDriverApiResponse, CreateDriverApiArg>({
      query: (queryArg) => ({
        url: `/dispatch-api/core/drivers/`,
        method: "POST",
        body: queryArg.createDriverBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    getDriverById: build.query<GetDriverByIdApiResponse, GetDriverByIdApiArg>({
      query: (queryArg) => ({
        url: `/dispatch-api/core/drivers/${queryArg.driverId}`,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    updateDriver: build.mutation<UpdateDriverApiResponse, UpdateDriverApiArg>({
      query: (queryArg) => ({
        url: `/dispatch-api/core/drivers/${queryArg.driverId}`,
        method: "PUT",
        body: queryArg.updateDriverBody,
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    archiveDriver: build.mutation<
      ArchiveDriverApiResponse,
      ArchiveDriverApiArg
    >({
      query: (queryArg) => ({
        url: `/dispatch-api/core/drivers/${queryArg.driverId}`,
        method: "DELETE",
        headers: {
          yard: queryArg.yard,
          organization: queryArg.organization,
          "request-id": queryArg["request-id"],
        },
      }),
    }),
    validateAddresses: build.mutation<
      ValidateAddressesApiResponse,
      ValidateAddressesApiArg
    >({
      query: (queryArg) => ({
        url: `/core-api/core/address/validate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as api };
export type GetAccountsApiResponse = /** status 200 account info */ AccountList;
export type GetAccountsApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateAccountApiResponse =
  /** status 200 account info */ AccountDto;
export type CreateAccountApiArg = {
  accountDto: AccountDto;
};
export type UpdateAccountApiResponse = /** status 200 Updated account */ object;
export type UpdateAccountApiArg = {
  /** Id of the account to update */
  accountId: string;
  body: object;
};
export type CreateAccountTransferApiResponse =
  /** status 200 Account transfer information */ object;
export type CreateAccountTransferApiArg = {
  body: object;
};
export type GetCommoditiesApiResponse =
  /** status 200 list of commodities */ CommodityList;
export type GetCommoditiesApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    assenending?: boolean;
  };
  /** The last key from the previous page for pagination */
  fromKey?: string;
};
export type CreateCommodityApiResponse =
  /** status 201 New Commodity created */ Commodity;
export type CreateCommodityApiArg = {
  commodity: Commodity;
};
export type PutCommodityApiResponse =
  /** status 200 Updated commodity */ Commodity;
export type PutCommodityApiArg = {
  commodity: Commodity;
};
export type GetCsvApiResponse = unknown;
export type GetCsvApiArg = void;
export type PostCsvApiResponse = unknown;
export type PostCsvApiArg = {
  body: {
    file?: string;
  };
};
export type GetPriceSheetCsvMultiApiResponse = unknown;
export type GetPriceSheetCsvMultiApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type PutPriceSheetCsvMultiApiResponse = unknown;
export type PutPriceSheetCsvMultiApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
  body: {
    file?: string;
  };
};
export type GetPriceSheetCsv2ApiResponse = unknown;
export type GetPriceSheetCsv2ApiArg = {
  priceSheetId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type PutPriceSheetCsv2ApiResponse = unknown;
export type PutPriceSheetCsv2ApiArg = {
  priceSheetId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  body: {
    file?: string;
  };
};
export type GetCommodityApiResponse =
  /** status 200 Commodity with id  */ Commodity;
export type GetCommodityApiArg = {
  /** Name of the commodity to get */
  commodityId: string;
};
export type UpdateCommodityApiResponse =
  /** status 200 Updated Commodity */ Commodity;
export type UpdateCommodityApiArg = {
  /** Id of the commodity to update */
  commodityId: string;
  commodity: Commodity;
};
export type GetCustomersApiResponse =
  /** status 200 list of customers */ CustomerList;
export type GetCustomersApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateCustomerApiResponse = /** status 200 New Customer */ Customer;
export type CreateCustomerApiArg = {
  customer: Customer;
};
export type GetCustomerInvoicesApiResponse =
  /** status 200 Successful response */ CustomerInvoiceList;
export type GetCustomerInvoicesApiArg = {
  customerId: string;
};
export type GetCustomerApiResponse =
  /** status 200 Customer with Id */ Customer;
export type GetCustomerApiArg = {
  /** ID of the customer to get */
  customerId: string;
};
export type UpdateCustomerApiResponse =
  /** status 200 Updated Customer */ Customer;
export type UpdateCustomerApiArg = {
  /** ID of the customer-profile-info to get */
  customerId: string;
  customer: Customer;
};
export type PatchCustomerApiResponse =
  /** status 200 Updated Customer */ object;
export type PatchCustomerApiArg = {
  /** ID of the customer-profile-info to update */
  customerId: string;
  body: object;
};
export type ArchiveCustomerApiResponse = unknown;
export type ArchiveCustomerApiArg = {
  /** ID of the customer to archive */
  customerId: string;
};
export type DeleteCustomerLocationApiResponse = unknown;
export type DeleteCustomerLocationApiArg = {
  customerId: string;
  locationId: string;
};
export type CheckBuyEligibilityApiResponse =
  /** status 200 Array of contacts */ any;
export type CheckBuyEligibilityApiArg = {
  body: any;
};
export type GetGsUserListApiResponse =
  /** status 200 Default Response */ GenericListResponse & {
    Items: UserListResponseItem[];
  };
export type GetGsUserListApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateGsUserApiResponse = /** status 200 Default Response */ object;
export type CreateGsUserApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
  createGsUserRequestBody: CreateGsUserRequestBody;
};
export type GetGsUserApiResponse =
  /** status 200 Default Response */ UserDetailResponse;
export type GetGsUserApiArg = {
  userId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type UpdateGsUserApiResponse = /** status 200 Default Response */ {};
export type UpdateGsUserApiArg = {
  userId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  updateGsUserRequestBody: UpdateGsUserRequestBody;
};
export type ResetGsUserPasswordApiResponse =
  /** status 200 Default Response */ {};
export type ResetGsUserPasswordApiArg = {
  userId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  resetUserPasswordRequestBody: ResetUserPasswordRequestBody;
};
export type GetTexasCashCardApiResponse =
  /** status 200 Texas cash card application and card url */ TexasCashCardResponseDto;
export type GetTexasCashCardApiArg = {
  /** ID of the contact to create card for */
  contactId: string;
};
export type CreateTexasCashCardApiResponse =
  /** status 200 Texas cash card application and card url */ TexasCashCardResponseDto;
export type CreateTexasCashCardApiArg = {
  texasCashCardRequestDto: TexasCashCardRequestDto;
};
export type InviteContactToPortalApiResponse =
  /** status 200 Default Response */ GsUserResponseBody;
export type InviteContactToPortalApiArg = {
  contactId: string;
  gsPortalUserRequestBody: GsPortalUserRequestBody;
};
export type GetSupplierTypesApiResponse =
  /** status 200 list of supplier types */ SupplierTypeList;
export type GetSupplierTypesApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateSupplierTypeApiResponse =
  /** status 200 New Supplier Type */ SupplierType;
export type CreateSupplierTypeApiArg = {
  supplierType: SupplierType;
};
export type PatchSupplierTypeApiResponse =
  /** status 201 Updated Supplier Type */ SupplierType;
export type PatchSupplierTypeApiArg = {
  supplierTypeId: string;
  body: object;
};
export type GetVendorClassesApiResponse =
  /** status 200 list of vendor classes */ VendorClassList;
export type GetVendorClassesApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateVendorClassApiResponse =
  /** status 200 New Vendor Class */ VendorClass;
export type CreateVendorClassApiArg = {
  vendorClass: VendorClass;
};
export type PatchVendorClassApiResponse =
  /** status 201 Updated Vendor Class */ VendorClass;
export type PatchVendorClassApiArg = {
  vendorClassId: string;
  body: object;
};
export type GetCustomerMaterialPurchasePriceHistoryApiResponse =
  /** status 200 purchase price history for material type and customer pair. */ CustomerMaterialPurchasePriceHistoryList;
export type GetCustomerMaterialPurchasePriceHistoryApiArg = {
  customerId: string;
  materialTypeId: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type GetFinishedGoodsApiResponse =
  /** status 200 list of finished goods */ FinishedGoods;
export type GetFinishedGoodsApiArg = {
  /** finished goods status, default is AVAILABLE */
  status?: "AVAILABLE" | "SHIPPED" | "ALL";
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
  /** The last key from the previous page for pagination */
  fromKey?: string;
};
export type CreateFinishedGoodApiResponse =
  /** status 201 New Finished Good created */ FinishedGood;
export type CreateFinishedGoodApiArg = {
  body: {
    finishedGood?: FinishedGoodRequestDto;
  };
};
export type GetFinishedGoodByIdApiResponse =
  /** status 200 Finished Good with id */ FinishedGood;
export type GetFinishedGoodByIdApiArg = {
  /** Finished Good id */
  id: string;
};
export type UpdateFinishedGoodApiResponse =
  /** status 200 Updated Finished Good */ FinishedGood;
export type UpdateFinishedGoodApiArg = {
  /** Finished Good id */
  id: string;
  body: {
    finishedGood?: FinishedGood;
  };
};
export type VoidFinishedGoodApiResponse = unknown;
export type VoidFinishedGoodApiArg = {
  /** Finished Good id */
  id: string;
};
export type GetFinishedGoodByTagApiResponse =
  /** status 200 Finished Good */ FinishedGood;
export type GetFinishedGoodByTagApiArg = {
  /** Finished Good Tag */
  tag: string;
};
export type GetInboundTicketsApiResponse =
  /** status 200 list of inbound tickets */ InboundTicketList;
export type GetInboundTicketsApiArg = {
  /** The last key from the previous page for pagination */
  fromKey?: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateInboundTicketApiResponse =
  /** status 200 New Inbound Ticket with Ticket Id */ InboundTicketView;
export type CreateInboundTicketApiArg = {
  inboundTicketSave: InboundTicketSave;
};
export type GetInboundTicketsByIdsApiResponse =
  /** status 200 List of inbound tickets with requested ids */ object;
export type GetInboundTicketsByIdsApiArg = {
  body: object;
};
export type GetInboundTicketNotesApiResponse =
  /** status 200 Default Response */ {
    id: string;
    note: string;
    date: string;
    userId: string;
    isInternal: boolean;
    inboundTicketId: string;
  }[];
export type GetInboundTicketNotesApiArg = {
  inboundTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type UpdateInboundTicketNotesApiResponse =
  /** status 200 Default Response */ {
    id: string;
    note: string;
    date: string;
    userId: string;
    isInternal: boolean;
    inboundTicketId: string;
  }[];
export type UpdateInboundTicketNotesApiArg = {
  inboundTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  body: {
    id: string;
    note: string;
    isInternal: boolean;
  }[];
};
export type CreateInboundTicketNoteApiResponse =
  /** status 201 Default Response */ {
    id: string;
    note: string;
    date: string;
    userId: string;
    isInternal: boolean;
    inboundTicketId: string;
  };
export type CreateInboundTicketNoteApiArg = {
  inboundTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  body: {
    note: string;
    isInternal: boolean;
  };
};
export type DeleteInboundTicketNoteApiResponse = unknown;
export type DeleteInboundTicketNoteApiArg = {
  inboundTicketId: string;
  ibtNoteId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type GetInboundTicketApiResponse =
  /** status 200 Default Response */ InboundTicketResponseItem;
export type GetInboundTicketApiArg = {
  /** ID of the ticket to get */
  ticketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type UpdateInboundTicketApiResponse =
  /** status 200 Updated Inbound Ticket */ InboundTicketView;
export type UpdateInboundTicketApiArg = {
  /** ID of the ticket to get */
  ticketId: string;
  inboundTicketSave: InboundTicketSave;
};
export type VoidInboundTicketApiResponse = unknown;
export type VoidInboundTicketApiArg = {
  /** ID of the ticket to void */
  ticketId: string;
};
export type GetInboundTicketQueuePaymentsApiResponse =
  /** status 200 Queue Payments of Ticket with Ticket Id */ QueuePaymentList;
export type GetInboundTicketQueuePaymentsApiArg = {
  /** ID of the ticket to get */
  inboundTicketId: string;
};
export type GetTexasXmlUploadFileApiResponse = unknown;
export type GetTexasXmlUploadFileApiArg = {
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
};
export type GetMaterialTypesApiResponse =
  /** status 200 list of Material Types */ MaterialTypeList;
export type GetMaterialTypesApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    assenending?: boolean;
  };
  /** The last key from the previous page for pagination */
  fromKey?: string;
};
export type CreateMaterialTypeApiResponse =
  /** status 201 New Material Type created */ MaterialType;
export type CreateMaterialTypeApiArg = {
  materialType: MaterialType;
};
export type GetMaterialTypeApiResponse =
  /** status 200 Material Type by id */ MaterialType;
export type GetMaterialTypeApiArg = {
  /** Name of the material type to get */
  materialTypeId: string;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
};
export type PatchMaterialTypeApiResponse =
  /** status 201 Updated Material Type */ MaterialType;
export type PatchMaterialTypeApiArg = {
  materialTypeId: string;
  body: {
    commodityId?: string;
    commonName?: string;
  };
};
export type ArchiveMaterialTypeApiResponse = unknown;
export type ArchiveMaterialTypeApiArg = {
  /** ID of the materialType to archive */
  materialTypeId: string;
};
export type GetMaterialsApiResponse =
  /** status 200 list of Materials */ MaterialView[];
export type GetMaterialsApiArg = {
  /** The last key from the previous page for pagination */
  fromKey?: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateMaterialApiResponse =
  /** status 201 New Material created */ MaterialView[];
export type CreateMaterialApiArg = {
  materialSave: MaterialSave;
};
export type GetMaterialApiResponse =
  /** status 200 Material by id */ MaterialView;
export type GetMaterialApiArg = {
  /** Name of the material to get */
  materialId: string;
};
export type UpdateMaterialApiResponse =
  /** status 200 Updated Material */ MaterialView;
export type UpdateMaterialApiArg = {
  /** id of the material */
  materialId: string;
  materialSave: MaterialSave;
};
export type GetOutboundTicketApiResponse =
  /** status 200 Oubound ticket */ OutboundTicket;
export type GetOutboundTicketApiArg = {
  /** outboundTicketId */
  outboundTicketId: string;
};
export type UpdateOutboundTicketApiResponse =
  /** status 200 Oubound ticket */ OutboundTicket;
export type UpdateOutboundTicketApiArg = {
  /** outboundTicketId */
  outboundTicketId: string;
  outboundTicketRequestDto: OutboundTicketRequestDto;
};
export type VoidOutboundTicketApiResponse = unknown;
export type VoidOutboundTicketApiArg = {
  /** outboundTicketId */
  outboundTicketId: string;
};
export type GetOutboundTicketsApiResponse =
  /** status 200 Outbound tickets */ OutboundTicketResponseDto;
export type GetOutboundTicketsApiArg = {
  /** The last key from the previous page for pagination */
  fromKey?: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateOutboundTicketApiResponse = unknown;
export type CreateOutboundTicketApiArg = {
  outboundTicketRequestDto: OutboundTicketRequestDto;
};
export type GetOutboundTicketsByIdsApiResponse =
  /** status 200 List of outbound tickets with requested ids */ object;
export type GetOutboundTicketsByIdsApiArg = {
  body: object;
};
export type GetPackingListsApiResponse =
  /** status 200 list of packing list */ PackingLists;
export type GetPackingListsApiArg = {
  /** packing list status, default is AVAILABLE */
  filter?: {
    key?: string;
    value?: string;
  };
  /** sortDescending=true or false. Default is false. Sort packing lists by created date, newest first. */
  sortDescending?: boolean;
};
export type CreatePackingListApiResponse =
  /** status 201 New Packing List created */ PackingList;
export type CreatePackingListApiArg = {
  packingListRequestDto: PackingListRequestDto;
};
export type GetPackingListByIdApiResponse =
  /** status 200 Packing List with id */ PackingList;
export type GetPackingListByIdApiArg = {
  /** Packing List id */
  packingListId: string;
};
export type UpdatePackingListApiResponse =
  /** status 200 Updated Packing List */ PackingList;
export type UpdatePackingListApiArg = {
  /** Packing List id */
  packingListId: string;
  packingList: PackingList;
};
export type VoidPackingListApiResponse = unknown;
export type VoidPackingListApiArg = {
  /** Packing List id */
  packingListId: string;
};
export type GetInventoryAdjustmentsApiResponse =
  /** status 200 list of Adjustments */ InventoryAdjustmentsList;
export type GetInventoryAdjustmentsApiArg = void;
export type CreateInventoryAdjustmentApiResponse =
  /** status 201 New Inventory Adjustment created */ InventoryAdjustment;
export type CreateInventoryAdjustmentApiArg = {
  inventoryAdjustment: InventoryAdjustment;
};
export type GetInventoryAdjustmentApiResponse =
  /** status 200 Adjustment with id */ InventoryAdjustment;
export type GetInventoryAdjustmentApiArg = {
  /** ID of the adjustment to get */
  id: string;
};
export type UpdateInventoryAdjustmentApiResponse =
  /** status 200 Updated Inventory Adjustment */ InventoryAdjustment;
export type UpdateInventoryAdjustmentApiArg = {
  /** ID of the adjustment to update */
  id: string;
  inventoryAdjustment: InventoryAdjustment;
};
export type DeleteInventoryAdjustmentApiResponse = unknown;
export type DeleteInventoryAdjustmentApiArg = {
  /** ID of the adjustment to void */
  id: string;
};
export type GetPriceSheetsApiResponse =
  /** status 200 list of price sheets */ PriceSheetList;
export type GetPriceSheetsApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    assenending?: boolean;
  };
  /** The last key from the previous page for pagination */
  fromKey?: string;
};
export type CreatePriceSheetApiResponse =
  /** status 201 New Price Sheet created */ PriceSheet;
export type CreatePriceSheetApiArg = {
  priceSheet: PriceSheet;
};
export type GetDefaultPriceSheetApiResponse =
  /** status 200 default price sheet */ PriceSheet;
export type GetDefaultPriceSheetApiArg = void;
export type GetPriceSheetApiResponse =
  /** status 200 PriceSheet with id */ PriceSheet;
export type GetPriceSheetApiArg = {
  /** Id of the priceSheet to get */
  priceSheetId: string;
  /** options for GET /price-sheets/:id */
  filter?: {
    key?: string;
    value?: string;
  };
};
export type UpdatePriceSheetApiResponse =
  /** status 200 Updated PriceSheet */ PriceSheet;
export type UpdatePriceSheetApiArg = {
  /** Id of the priceSheet to update */
  priceSheetId: string;
  priceSheet: PriceSheet;
};
export type ArchivePriceSheetApiResponse = unknown;
export type ArchivePriceSheetApiArg = {
  /** Id of the priceSheet to archive */
  priceListId: string;
};
export type DeletePriceEntryApiResponse = unknown;
export type DeletePriceEntryApiArg = {
  /** Id of the priceSheet to delete */
  priceSheetId: string;
  /** Id of the materialType to delete */
  materialTypeId: string;
};
export type GetPriceSheetCsvApiResponse = unknown;
export type GetPriceSheetCsvApiArg = void;
export type UploadNewPriceSheetsApiResponse =
  /** status 200 PriceSheets Uploaded */ {
    rowcount?: number;
  };
export type UploadNewPriceSheetsApiArg = {
  body: {
    organization?: string;
    yard?: string;
    fileObject?: Blob;
  };
};
export type UploadUpdatePriceSheetsApiResponse =
  /** status 200 PriceSheet Uploaded */ {
    rowcount?: number;
  };
export type UploadUpdatePriceSheetsApiArg = {
  body: {
    fileName?: string;
    fileObject?: Blob;
  };
};
export type MergeInboundTicketsApiResponse = unknown;
export type MergeInboundTicketsApiArg = {
  /** parent inboundTicketId */
  id: string;
  mergeIbtsRequest: MergeIbtsRequest;
};
export type GetRegradesApiResponse =
  /** status 200 list of regrades */ Regrades;
export type GetRegradesApiArg = {
  /** regrade archive status */
  archive?: boolean;
  /** sortDescending=true or false. Default is false. Sort regrades by created date, newest first. */
  sortDescending?: boolean;
};
export type CreateRegradeApiResponse = /** status 201  */ RegradeResponseDto;
export type CreateRegradeApiArg = {
  regradeDto: RegradeDto;
};
export type GetRegradeByIdApiResponse =
  /** status 200 Returns RegradeResponseDTO */ RegradeResponseDto;
export type GetRegradeByIdApiArg = {
  /** Regrade id */
  regradeId: string;
};
export type UpdateRegradeApiResponse = /** status 200  */ RegradeResponseDto;
export type UpdateRegradeApiArg = {
  /** Regrade id */
  regradeId: string;
  regradeDto: RegradeDto;
};
export type VoidRegradeApiResponse = unknown;
export type VoidRegradeApiArg = {
  /** regrade id */
  regradeId: string;
};
export type GetInventoryCommodityHandlerApiResponse =
  /** status 200 Weight and price of each commodity */ CommoditiesInventorySummary;
export type GetInventoryCommodityHandlerApiArg = {
  /** The last key from the previous page for pagination */
  fromKey?: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type GetInventoryByCommodityApiResponse =
  /** status 200 Weight and price of each material of type commodityId */ CommodityInventoryDetail;
export type GetInventoryByCommodityApiArg = {
  /** Commodity Id to get inventory for */
  commodityId: string;
};
export type GetInventoryFinishedGoodListApiResponse =
  /** status 200 Weight and price of each FinishedGood */ InventoryFinishedGoodList;
export type GetInventoryFinishedGoodListApiArg = {
  /** The last key from the previous page for pagination */
  fromKey?: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type GetInventoryRegradeMetaApiResponse =
  /** status 200 Meta Data of Regrades in Inventory */ InventoryRegradeMeta;
export type GetInventoryRegradeMetaApiArg = {
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
};
export type GetInventoryPackingListMetaApiResponse =
  /** status 200 Meta Data of Packing Lists in Inventory */ InventoryPackingListMeta;
export type GetInventoryPackingListMetaApiArg = {
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
};
export type GetInventoryMaterialTypeApiResponse =
  /** status 200 Weight and price of each material of type materialTypeId */ InventoryMaterialType;
export type GetInventoryMaterialTypeApiArg = {
  /** MaterialType Id to get inventory for */
  materialTypeId: string;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
};
export type GetInventoryMaterialTypeByIdsApiResponse =
  /** status 200 List of inventory for material types with requested ids */ object;
export type GetInventoryMaterialTypeByIdsApiArg = {
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  body: object;
};
export type GetNegativeInventoryListApiResponse =
  /** status 200 List of material types with a negative inventory and price of each material of type materialTypeId */ object;
export type GetNegativeInventoryListApiArg = {
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
};
export type GetOrganizationApiResponse =
  /** status 200 Default Response */ OrganizationResponseSchema;
export type GetOrganizationApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type GetBenchmarksApiResponse =
  /** status 200 Get benchmarks */ BenchmarkList;
export type GetBenchmarksApiArg = {
  /** The last key from the previous page for pagination */
  fromKey?: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateBenchmarkApiResponse =
  /** status 200 New Benchmark with Benchmark Id */ Benchmark;
export type CreateBenchmarkApiArg = {
  benchmark: Benchmark;
};
export type GetBenchmarkByIdApiResponse =
  /** status 200 Returns Benchmark */ Benchmark;
export type GetBenchmarkByIdApiArg = {
  /** Benchmark id */
  benchmarkId: string;
};
export type UpdateBenchmarkApiResponse = /** status 201  */ Benchmark;
export type UpdateBenchmarkApiArg = {
  /** Benchmark id */
  benchmarkId: string;
  benchmark: Benchmark;
};
export type GetPriceEntriesApiResponse =
  /** status 200 Price Entries */ PriceEntryList;
export type GetPriceEntriesApiArg = {
  /** The last key from the previous page for pagination */
  fromKey?: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreatePriceEntryApiResponse =
  /** status 200 New PriceEntry with PriceEntry Id */ PriceEntry;
export type CreatePriceEntryApiArg = {
  priceEntry: PriceEntry;
};
export type GetPriceEntryApiResponse = /** status 200 PriceEntry */ PriceEntry;
export type GetPriceEntryApiArg = {
  /** ID of the PriceEntry to get */
  priceEntryId: string;
};
export type UpdatePriceEntryApiResponse =
  /** status 200 Updated PriceEntry */ PriceEntry;
export type UpdatePriceEntryApiArg = {
  /** ID of the PriceEntry to get */
  priceEntryId: string;
  priceEntry: PriceEntry;
};
export type GetPriceEntryHistoryByMaterialIdApiResponse =
  /** status 200 Price Change History for a Material Type ID */ PriceEntryHistory;
export type GetPriceEntryHistoryByMaterialIdApiArg = {
  /** material type id */
  materialTypeId: string;
};
export type GetSalesOrdersApiResponse =
  /** status 200 list of sales orders */ SalesOrderList;
export type GetSalesOrdersApiArg = void;
export type CreateSalesOrderApiResponse =
  /** status 200 New Sales Order with Sales Order Id */ SalesOrder;
export type CreateSalesOrderApiArg = {
  salesOrderCreation: SalesOrderCreation;
};
export type GetSalesOrderApiResponse = /** status 200 Sales Order */ SalesOrder;
export type GetSalesOrderApiArg = {
  /** ID of the sales order to get */
  salesOrderId: string;
};
export type UpdateSalesOrderApiResponse =
  /** status 200 Updated Sales Order */ SalesOrder;
export type UpdateSalesOrderApiArg = {
  /** ID of the sales order to get */
  salesOrderId: string;
  salesOrder: SalesOrder;
};
export type ArchiveSalesOrderApiResponse =
  /** status 200 Archived Sales Order */ SalesOrder;
export type ArchiveSalesOrderApiArg = {
  /** ID of the sales order to archive */
  salesOrderId: string;
  body: object;
};
export type GetSalesOrdersCsvApiResponse = unknown;
export type GetSalesOrdersCsvApiArg = void;
export type UploadSalesOrdersCsvApiResponse = unknown;
export type UploadSalesOrdersCsvApiArg = {
  body: {
    file?: string;
  };
};
export type GetPurchaseOrdersV2ApiResponse =
  /** status 200 list of purchase orders */ object;
export type GetPurchaseOrdersV2ApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type GetPurchaseOrdersApiResponse =
  /** status 200 list of purchase orders */ PurchaseOrderList;
export type GetPurchaseOrdersApiArg = void;
export type CreatePurchaseOrderApiResponse =
  /** status 200 New Purchase Order with Purchase Order Id */ PurchaseOrder;
export type CreatePurchaseOrderApiArg = {
  purchaseOrderCreation: PurchaseOrderCreation;
};
export type ArchivePurchaseOrderApiResponse =
  /** status 200 Archived Purchase Order */ PurchaseOrder;
export type ArchivePurchaseOrderApiArg = {
  /** ID of the purchase order to archive */
  purchaseOrderId: string;
  body: object;
};
export type GetPurchaseOrderApiResponse =
  /** status 200 Purchase Order */ PurchaseOrder;
export type GetPurchaseOrderApiArg = {
  /** ID of the purchase order to get */
  purchaseOrderId: string;
};
export type UpdatePurchaseOrderApiResponse =
  /** status 200 Updated Purchase Order */ PurchaseOrder;
export type UpdatePurchaseOrderApiArg = {
  /** ID of the purchase order to get */
  purchaseOrderId: string;
  purchaseOrder: PurchaseOrder;
};
export type GetPurchaseOrdersCsvApiResponse = unknown;
export type GetPurchaseOrdersCsvApiArg = void;
export type UploadPurchaseOrdersCsvApiResponse = unknown;
export type UploadPurchaseOrdersCsvApiArg = {
  body: {
    file?: string;
  };
};
export type DeleteInvoiceBulkPaymentApiResponse = unknown;
export type DeleteInvoiceBulkPaymentApiArg = {
  /** ID of the payment to void */
  paymentId: string;
};
export type CreateInvoiceBulkPaymentApiResponse =
  /** status 200 Successfully created invoice bulk payment */ InvoiceBulkPaymentResponse;
export type CreateInvoiceBulkPaymentApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
  invoiceBulkPaymentCreation: InvoiceBulkPaymentCreation;
};
export type GetInvoicePaymentsApiResponse =
  /** status 200 list of all invoice payments */ Blob;
export type GetInvoicePaymentsApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
};
export type GetInvoicesV2ApiResponse =
  /** status 200 Default Response */ GenericListResponse & {
    Items: InvoiceListResponse[];
  };
export type GetInvoicesV2ApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateInvoiceV2ApiResponse =
  /** status 200 Default Response */ InvoiceResponseV2;
export type CreateInvoiceV2ApiArg = {
  invoiceRequestBody: InvoiceRequestBody;
};
export type CreateInboundInvoiceV2ApiResponse =
  /** status 201 Created inbound invoice */ InvoiceResponseV3;
export type CreateInboundInvoiceV2ApiArg = {
  invoiceInboundRequestBody: InvoiceInboundRequestBody;
};
export type UpdateInboundInvoiceV2ApiResponse =
  /** status 201 Updated inbound invoice */ InvoiceResponseV3;
export type UpdateInboundInvoiceV2ApiArg = {
  invoiceId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  invoiceInboundRequestBody: InvoiceInboundRequestBody;
};
export type GetInvoicePaymentApiResponse =
  /** status 200 Successful response */ InvoicePaymentResponse;
export type GetInvoicePaymentApiArg = {
  paymentId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type GetInvoiceV2ApiResponse =
  /** status 200 Default Response */ InvoiceResponseV2;
export type GetInvoiceV2ApiArg = {
  /** ID of the invoice to get */
  invoiceId: string;
};
export type UpdateInvoiceV2ApiResponse =
  /** status 200 Updated Invoice */ InvoiceResponseV2;
export type UpdateInvoiceV2ApiArg = {
  /** ID of the invoice to get */
  invoiceId: string;
  body: object;
};
export type GetInvoiceV3ApiResponse =
  /** status 200 Default Response */ InvoiceResponseV3;
export type GetInvoiceV3ApiArg = {
  /** ID of the invoice to get */
  invoiceId: string;
};
export type VoidInvoiceApiResponse = /** status 200 Voided invoice */ object;
export type VoidInvoiceApiArg = {
  /** ID of the invoice to void */
  invoiceId: string;
  body: object;
};
export type GetDevicesApiResponse = /** status 200 Device List */ Device[];
export type GetDevicesApiArg = {
  /** JSON filter object */
  filter?: string;
};
export type CaptureImageApiResponse = unknown;
export type CaptureImageApiArg = {
  /** The device id */
  deviceId: string;
  /** Return results that match key=value */
  filename?: {
    key?: string;
    value?: string;
  };
};
export type CreateQzTraySignatureApiResponse =
  /** status 200 base64 encoded signature */ {
    signature: string;
  };
export type CreateQzTraySignatureApiArg = {
  yard?: string;
  organization?: string;
  body: {
    toSign: string;
  };
};
export type GetOrgImageApiResponse = /** status 200 Org Image */ string;
export type GetOrgImageApiArg = {
  /** Filename (with extension) of org image */
  filename: string;
  /** Whether or not org image is in temp folder */
  isTemp?: boolean;
  /** How long the presigned URL should expire in seconds */
  expiresIn?: number;
};
export type UploadOrgImageApiResponse =
  /** status 201 org image uploaded */ ImageSavedResponse;
export type UploadOrgImageApiArg = {
  body: {
    image?: Blob;
  };
};
export type GetBillsApiResponse = /** status 200 list of bills */ object;
export type GetBillsApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
};
export type GetBillApiResponse = /** status 200 Bill */ Bill;
export type GetBillApiArg = {
  /** ID of the bill to get */
  billId: string;
};
export type UpdateBillApiResponse = /** status 200 Updated Bill */ Bill;
export type UpdateBillApiArg = {
  /** ID of the bill to update */
  billId: string;
  body: object;
};
export type MergeBillApiResponse = /** status 200 Merged Bill */ object;
export type MergeBillApiArg = {
  /** ID of the bill to merge to */
  billId: string;
  body: object;
};
export type UnmergeBillApiResponse = unknown;
export type UnmergeBillApiArg = {
  /** ID of the bill to void */
  billId: string;
  body: object;
};
export type UpdateAndMergeBillApiResponse = unknown;
export type UpdateAndMergeBillApiArg = {
  /** ID of the bill to update and merge */
  billId: string;
  body: object;
};
export type VoidBillApiResponse = unknown;
export type VoidBillApiArg = {
  /** ID of the bill to void */
  billId: string;
  body: object;
};
export type GetPaymentsApiResponse =
  /** status 200 list of payments */ PaymentList;
export type GetPaymentsApiArg = void;
export type CreatePaymentApiResponse =
  /** status 200 New Payment with Payment Id */ Payment;
export type CreatePaymentApiArg = {
  paymentCreation: PaymentCreation;
};
export type GetPaymentApiResponse = /** status 200 Payment */ Payment;
export type GetPaymentApiArg = {
  /** ID of the payment to get */
  paymentId: string;
};
export type UpdatePaymentApiResponse =
  /** status 200 Updated Payment */ Payment;
export type UpdatePaymentApiArg = {
  /** ID of the payment to update */
  paymentId: string;
  payment: Payment;
};
export type VoidPaymentApiResponse = unknown;
export type VoidPaymentApiArg = {
  /** ID of the payment to void */
  paymentId: string;
};
export type GetItemsToSyncApiResponse =
  /** status 200 get items to sync */ object;
export type GetItemsToSyncApiArg = {
  syncStatus: string;
};
export type SyncItemsApiResponse = /** status 201 sync successful */ object;
export type SyncItemsApiArg = {
  /** abbrevieted name of the ERP tool that this customer uses such as quickbooks online = qbo, microsoft business central = mbc */
  erpProvider: string;
  body: object;
};
export type GetBatchesApiResponse =
  /** status 200 Default Response */ GenericListResponse & {
    Items: ErpSyncBatch[];
  };
export type GetBatchesApiArg = void;
export type GetBatchApiResponse =
  /** status 200 Default Response */ ErpSyncBatch;
export type GetBatchApiArg = {
  /** ID of the batch to get */
  batchId: string;
};
export type MarkItemsAsCompletedApiResponse =
  /** status 201 marked as completed successful */ object;
export type MarkItemsAsCompletedApiArg = {
  body: object;
};
export type SendEmailApiResponse = /** status 200 Default Response */ object;
export type SendEmailApiArg = {
  page?: number;
  pageSize?: number;
  filter?: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  body: {
    recipients?: string[];
    entityId?: string;
    pdfType?:
      | "IBT_PURCHASE_TICKET"
      | "IBT_SCALE_TICKET"
      | "BILL_SETTLEMENT_DOC"
      | "OBT_PACKING_LIST"
      | "OBT_BILL_OF_LADING"
      | "INVOICE"
      | "PAYMENT_RECEIPT";
    includeImages?: boolean;
    idempotencyKey?: string;
  };
};
export type SendOutboundTicketEmailApiResponse =
  /** status 200 Default Response */ object;
export type SendOutboundTicketEmailApiArg = {
  body: {
    recipients?: string[];
    entityId?: string;
    emailType?: "OBT_PACKING_LIST" | "OBT_BILL_OF_LADING" | "OBT_PL_AND_BOL";
    includeImages?: boolean;
    idempotencyKey?: string;
  };
};
export type GetPermissionsApiResponse =
  /** status 200 list of permissions */ Permissions;
export type GetPermissionsApiArg = void;
export type GetLicenseInfoApiResponse =
  /** status 200 driver info. */ IdScanResponse;
export type GetLicenseInfoApiArg = {
  body: {
    image?: Blob;
  };
};
export type GetVehicleInfoFromVinApiResponse =
  /** status 200 driver info. */ VinDecoderResponse;
export type GetVehicleInfoFromVinApiArg = {
  /** vehicle vin must be length of 17. */
  vin: string;
};
export type GetPullApartScrapRowsApiResponse = unknown;
export type GetPullApartScrapRowsApiArg = void;
export type GetInvoicePaymentByInvoiceIdApiResponse =
  /** status 200 invoice payments. */ InvoicePaymentsResponse;
export type GetInvoicePaymentByInvoiceIdApiArg = {
  /** invoice id. */
  invoiceId: string;
};
export type CreateInvoicePaymentApiResponse = /** status 201 created. */ {
  id?: string;
};
export type CreateInvoicePaymentApiArg = {
  /** invoice id. */
  invoiceId: string;
  invoicePaymentRequest: InvoicePaymentRequest;
};
export type GetYardApiResponse =
  /** status 200 Default Response */ GenericListResponse & {
    Items: YardResponseSchema[];
  };
export type GetYardApiArg = {
  /** yard id */
  yardId: string;
  page?: number;
  pageSize?: number;
  filter?: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type GetSettingsApiResponse = /** status 200 Default Response */ {
  contractSettings?: {
    salesOrders?: {
      [key: string]: any;
    };
    purchaseOrders?: {
      [key: string]: any;
    };
    autoCloseContracts?: {
      [key: string]: any;
    };
  };
  customerSettings?: {
    supplierGroupings?: {
      [key: string]: any;
    };
  };
  purchaseSettings?: {
    payment?: {
      [key: string]: any;
    };
    deductions?: {
      [key: string]: any;
    };
    inboundTickets?: {
      [key: string]: any;
    };
    cashDrawers?: {
      [key: string]: any;
    };
    scaleView?: {
      [key: string]: any;
    };
  };
  inventorySettings?: {
    general?: {
      [key: string]: any;
    };
    finishedGoods?: {
      [key: string]: any;
    };
    outboundTickets?: {
      [key: string]: any;
    };
  };
  erpSettings?: {
    general?: {
      [key: string]: any;
    };
  };
  dispatchSettings?: {
    loadBoard?: {
      [key: string]: any;
    };
  };
  overviewSettings?: {
    lockAccountingDate?: {
      [key: string]: any;
    };
    isLockedForAccounting?: {
      [key: string]: any;
    };
  };
  documentSettings?: {
    general?: {
      [key: string]: any;
    };
  };
  adminSettings?: AdminSettings;
};
export type GetSettingsApiArg = {
  /** The argument does nothing to BE request its only here for RTK query caching. It lets us have multiple cache keys for same api endpoint. */
  origin?: string;
};
export type PostSettingsRbacApiResponse =
  /** status 200 Default Response */ object;
export type PostSettingsRbacApiArg = {
  yard?: string;
  organization?: string;
  adminRbacSettings: AdminRbacSettings;
};
export type GetFpSettingsApiResponse =
  /** status 200 Default Response */ GenericListResponse & {
    Items: FeeOrPromotionSettingResponseBody[];
  };
export type GetFpSettingsApiArg = {
  filter?: string;
};
export type CreateFeeOrPromotionPresetApiResponse =
  /** status 200 Default Response */ {
    id: string;
  };
export type CreateFeeOrPromotionPresetApiArg = {
  feeOrPromotionSettingBody: FeeOrPromotionSettingBody;
};
export type UpdateFeeOrPromotionPresetApiResponse =
  /** status 200 Default Response */ {
    id: string;
  };
export type UpdateFeeOrPromotionPresetApiArg = {
  feeOrPromotionId: string;
  updateFeeOrPromotionSettingBody: UpdateFeeOrPromotionSettingBody;
};
export type ArchiveFeeOrPromotionPresetApiResponse =
  /** status 200 Default Response */ {
    id: string;
  };
export type ArchiveFeeOrPromotionPresetApiArg = {
  feeOrPromotionId: string;
};
export type UpdateSettingsApiResponse =
  /** status 200 updated setting */ object;
export type UpdateSettingsApiArg = {
  /** category of the setting */
  category: string;
  /** subcategory of the setting */
  subCategory: string;
  body: object;
};
export type GetTransfersApiResponse = /** status 200 transfers */ object;
export type GetTransfersApiArg = void;
export type GetTransferApiResponse = /** status 200 transfer */ object;
export type GetTransferApiArg = {
  /** ID of the transfer to get */
  transferId: string;
};
export type GetScaleReadingApiResponse = /** status 200 scale reading */ object;
export type GetScaleReadingApiArg = {
  /** id of the scale device */
  deviceId: string;
};
export type CreateVehicleApiResponse = /** status 200 New Vehicle */ Vehicle;
export type CreateVehicleApiArg = {
  vehicle: Vehicle;
};
export type GetVehiclesApiResponse = /** status 200 Vehicles */ VehicleList;
export type GetVehiclesApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type GetVehicleApiResponse =
  /** status 200 Vehicle with requested id */ Vehicle;
export type GetVehicleApiArg = {
  /** ID of the vehicle to get */
  vehicleId: string;
};
export type UpdateVehicleApiResponse =
  /** status 200 Updated Vehicle */ Vehicle;
export type UpdateVehicleApiArg = {
  /** ID of the vehicle to update */
  vehicleId: string;
  vehicle: Vehicle;
};
export type SaveGsPayVendorApiResponse =
  /** status 200 Default Response */ SaveGsPayVendorResponse;
export type SaveGsPayVendorApiArg = {
  saveGsPayVendorRequest: SaveGsPayVendorRequest;
};
export type GetFreightBillsApiResponse =
  /** status 200 List of freight bills that can be merged */ object;
export type GetFreightBillsApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
};
export type GetBatchBillsApiResponse =
  /** status 200 List of batch bills */ GenericListResponse &
    BatchBillListResponse;
export type GetBatchBillsApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
};
export type CreateBatchBillApiResponse =
  /** status 200 New batch bill */ BatchBillResponseBody;
export type CreateBatchBillApiArg = {
  batchBillRequestBody: BatchBillRequestBody;
};
export type GetBatchBillApiResponse =
  /** status 200 Default Response */ BatchBillResponseBody;
export type GetBatchBillApiArg = {
  /** ID of the batch bill to get */
  batchBillId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type UpdateBatchBillApiResponse =
  /** status 200 Updated batch bill */ BatchBillResponseBody;
export type UpdateBatchBillApiArg = {
  /** ID of the batch bill to update */
  batchBillId: string;
  billIds?: string[];
  batchBillRequestBody: BatchBillRequestBody;
};
export type PayBatchBillApiResponse = /** status 200 Default Response */ object;
export type PayBatchBillApiArg = {
  /** ID of the batch bill to pay */
  batchBillId: string;
  billIds?: string[];
  body: {
    idempotencyKey?: string;
  };
};
export type GetVehicleMakeModelsApiResponse = unknown;
export type GetVehicleMakeModelsApiArg = void;
export type GetCurrencyConversionsApiResponse =
  /** status 200 Currency conversion table + history */ object;
export type GetCurrencyConversionsApiArg = {
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
};
export type UpdateCurrencyConversionsApiResponse =
  /** status 200 Updated currency conversion table + history */ object;
export type UpdateCurrencyConversionsApiArg = {
  body: object;
};
export type GetLockAccountingPeriodApiResponse =
  /** status 200 Lock accounting period settings */ LockAccountingPeriodSchema;
export type GetLockAccountingPeriodApiArg = void;
export type UpdateLockAccountingPeriodApiResponse =
  /** status 200 Updated lock accounting period settings */ LockAccountingPeriodSchema;
export type UpdateLockAccountingPeriodApiArg = {
  body: {
    lockAccountingDate?: string;
    isLockedForAccounting?: boolean;
  };
};
export type GetLockedEntitiesApiResponse =
  /** status 200 Entities in the locked accounting period */ GenericListResponse & {
    Items: LockedEntitySchema[];
  };
export type GetLockedEntitiesApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
};
export type GetFreightLanesApiResponse =
  /** status 200 List of freight lanes */ object;
export type GetFreightLanesApiArg = {
  /** Return results that match key=value */
  filter?: {
    key?: string;
    value?: string;
  };
};
export type CreateFreightLaneApiResponse =
  /** status 200 New freight lane */ object;
export type CreateFreightLaneApiArg = {
  body: object;
};
export type GetFreightLaneApiResponse = /** status 200 Freight lane */ object;
export type GetFreightLaneApiArg = {
  /** ID of the freight lane to get */
  id: string;
};
export type UpdateFreightLaneApiResponse =
  /** status 200 Updated freight lane */ object;
export type UpdateFreightLaneApiArg = {
  /** ID of the freight lane to update */
  id: string;
  body: object;
};
export type GetFreightLaneLocationsApiResponse =
  /** status 200 List of freight lane locations */ object;
export type GetFreightLaneLocationsApiArg = void;
export type CreateFreightLaneLocationApiResponse =
  /** status 200 New freight lane location */ object;
export type CreateFreightLaneLocationApiArg = {
  body: object;
};
export type UpdateFreightLaneLocationApiResponse =
  /** status 200 Updated freight lane location */ object;
export type UpdateFreightLaneLocationApiArg = {
  /** ID of the freight lane location to update */
  id: string;
  body: object;
};
export type GetFreightLanePricesApiResponse =
  /** status 200 List of prices for a specific freight lane */ object;
export type GetFreightLanePricesApiArg = {
  /** ID of the freight lane to get prices for */
  id: string;
};
export type UpdateFreightLanePricesApiResponse =
  /** status 200 Updated list of prices for a specific freight lane */ object;
export type UpdateFreightLanePricesApiArg = {
  /** ID of the freight lane to create/update prices for */
  id: string;
  body: object;
};
export type GetMetabaseUrlApiResponse = unknown;
export type GetMetabaseUrlApiArg = {
  /** Report ID */
  reportId: number;
  /** Custom parameters for the report */
  customParams?: string;
};
export type GetPaymentTermsApiResponse =
  /** status 200 List of payment terms */ PaymentTermList;
export type GetPaymentTermsApiArg = void;
export type CreatePaymentTermApiResponse =
  /** status 200 New payment term */ PaymentTerm;
export type CreatePaymentTermApiArg = {
  paymentTerm: PaymentTerm;
};
export type PatchPaymentTermApiResponse =
  /** status 201 Updated Payment Term */ PaymentTerm;
export type PatchPaymentTermApiArg = {
  /** payment term id */
  paymentTermId: string;
  body: {
    paymentTermId?: string;
    display?: string;
    days?: number;
  };
};
export type DeactivatePaymentTermApiResponse = unknown;
export type DeactivatePaymentTermApiArg = {
  /** Payment Term id */
  paymentTermId: string;
};
export type GetAssetsByCategoryApiResponse =
  /** status 200 Default Response */ GenericListResponse & {
    Items: AssetResponseSchema[];
  };
export type GetAssetsByCategoryApiArg = {
  page?: number;
  pageSize?: number;
  filter?: string;
  assetCategory: "CONTAINER" | "TRUCK" | "TRAILER";
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type CreatePhysicalAssetApiResponse =
  /** status 201 New Physical Asset created */ PhysicalAsset;
export type CreatePhysicalAssetApiArg = {
  /** asset category */
  assetCategory: string;
  physicalAsset: PhysicalAsset;
};
export type GetAssetByCategoryAndIdApiResponse = /** status 200 asset */ object;
export type GetAssetByCategoryAndIdApiArg = {
  /** asset category */
  assetCategory: string;
  /** asset id */
  assetId: string;
};
export type PatchPhysicalAssetApiResponse =
  /** status 201 Updated Physical Asset */ PhysicalAsset;
export type PatchPhysicalAssetApiArg = {
  /** asset category */
  assetCategory: string;
  /** asset id */
  assetId: string;
  body: {
    assetId?: string;
    assetCategory?: string;
  };
};
export type GetAssetTypesApiResponse = /** status 200 asset types */ object;
export type GetAssetTypesApiArg = {
  /** asset category */
  assetCategory: string;
};
export type CreateAssetTypesApiResponse = /** status 200 asset types */ object;
export type CreateAssetTypesApiArg = {
  /** asset category */
  assetCategory: string;
  body: object;
};
export type UpdateAssetTypesApiResponse = /** status 200 asset types */ object;
export type UpdateAssetTypesApiArg = {
  /** asset category */
  assetCategory: string;
  /** asset type id */
  assetTypeId: string;
  body: object;
};
export type GetAssetHistoryApiResponse =
  /** status 200 Asset history response */ object;
export type GetAssetHistoryApiArg = {
  /** The category of the asset */
  assetCategory?: string;
  /** The id of the asset */
  assetId?: string;
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Return results that match the search string */
  filter?: {
    search?: string;
  };
  /** Sorts the results based on the field and direction */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
};
export type CreateAssetStatusApiResponse =
  /** status 200 New asset status for the specified asset id */ object;
export type CreateAssetStatusApiArg = {
  /** asset category */
  assetCategory: string;
  /** asset id */
  assetId: string;
  body: object;
};
export type GetDispatchTicketsApiResponse =
  /** status 200 Default Response */ GenericListResponse & {
    Items: DispatchTicketSchema[];
  };
export type GetDispatchTicketsApiArg = {
  /** The page of values given pageSize, defaults to 1 */
  page?: number;
  /** The size of a page, defaults to 10 */
  pageSize?: number;
  /** Sent as a stringified JSON. The available filter options differ by endpoint. */
  filter?: string;
  /** Sort results by field in either ascending or descending order */
  sort?: {
    field?: string;
    ascending?: boolean;
  };
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type CreateDispatchTicketApiResponse =
  /** status 200 Default Response */ DispatchTicketSchema;
export type CreateDispatchTicketApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
  createDispatchTicketBody: CreateDispatchTicketBody;
};
export type PatchMultipleDispatchTicketsApiResponse =
  /** status 200 Default Response */ DispatchTicketSchema[];
export type PatchMultipleDispatchTicketsApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
  body: PatchDispatchTicketBody[];
};
export type GetDispatchTicketApiResponse =
  /** status 200 Default Response */ DispatchTicketSchema;
export type GetDispatchTicketApiArg = {
  /** ID of the ticket to get */
  dispatchTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type UpdateDispatchTicketApiResponse =
  /** status 200 Default Response */ DispatchTicketSchema;
export type UpdateDispatchTicketApiArg = {
  dispatchTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  updateDispatchTicketBody: UpdateDispatchTicketBody;
};
export type PatchDispatchTicketApiResponse =
  /** status 200 Default Response */ DispatchTicketSchema;
export type PatchDispatchTicketApiArg = {
  dispatchTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  patchDispatchTicketBody: PatchDispatchTicketBody;
};
export type VoidDispatchTicketApiResponse =
  /** status 200 Default Response */ DispatchTicketSchema;
export type VoidDispatchTicketApiArg = {
  /** ID of the ticket to get */
  dispatchTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  voidDispatchTicketBody: VoidDispatchTicketBody;
};
export type GetRecurringDispatchTicketsApiResponse =
  /** status 200 List of recurring dispatch tickets */ GenericListResponse & {
    Items: RecurringDispatchTicketSchema[];
  };
export type GetRecurringDispatchTicketsApiArg = {
  page?: number;
  pageSize?: number;
  filter?: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type CreateRecurringDispatchTicketApiResponse =
  /** status 200 Created recurring dispatch ticket */ RecurringDispatchTicketSchema;
export type CreateRecurringDispatchTicketApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
  recurringDispatchTicketSchema: RecurringDispatchTicketSchema;
};
export type GetRecurringDispatchTicketApiResponse =
  /** status 200 Recurring dispatch ticket */ RecurringDispatchTicketSchema;
export type GetRecurringDispatchTicketApiArg = {
  recurringDispatchTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type UpdateRecurringDispatchTicketApiResponse =
  /** status 201 Updated recurring dispatch ticket */ RecurringDispatchTicketSchema;
export type UpdateRecurringDispatchTicketApiArg = {
  recurringDispatchTicketId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  recurringDispatchTicketSchema: RecurringDispatchTicketSchema;
};
export type ArchiveRecurringDispatchTicketApiResponse =
  /** status 200 Archived recurring dispatch ticket */ RecurringDispatchTicketSchema;
export type ArchiveRecurringDispatchTicketApiArg = {
  recurringDispatchTicketId: string;
  dispatchTicketId?: string;
  deleteDispatchTicket?: boolean;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type GetDriversApiResponse =
  /** status 200 List of Drivers */ GenericListResponse & {
    Items: DriverResponseBody[];
  };
export type GetDriversApiArg = {
  page?: number;
  pageSize?: number;
  filter?: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type CreateDriverApiResponse =
  /** status 200 Created Driver */ DriverResponseBody;
export type CreateDriverApiArg = {
  yard?: string;
  organization?: string;
  "request-id"?: string;
  createDriverBody: CreateDriverBody;
};
export type GetDriverByIdApiResponse =
  /** status 200 Driver */ DriverResponseBody;
export type GetDriverByIdApiArg = {
  driverId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type UpdateDriverApiResponse =
  /** status 201 Updated Driver */ DriverResponseBody;
export type UpdateDriverApiArg = {
  driverId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
  updateDriverBody: UpdateDriverBody;
};
export type ArchiveDriverApiResponse =
  /** status 200 Archived Driver */ DriverResponseBody;
export type ArchiveDriverApiArg = {
  driverId: string;
  yard?: string;
  organization?: string;
  "request-id"?: string;
};
export type ValidateAddressesApiResponse =
  /** status 200 Successfully validated addresses */ {
    results: {
      locationId: string;
      formattedAddress: string;
      coordinates: {
        lat: number;
        lng: number;
      };
      valid: boolean;
    }[];
  };
export type ValidateAddressesApiArg = {
  body: {
    locationIds: string[];
  };
};
export type AccountDto = {
  id?: string | null;
  name?: string;
  type?: string;
  ledgerCode?: string;
};
export type AccountList = AccountDto[];
export type CommodityType = "FERROUS" | "NON_FERROUS" | "WASTE" | "OTHER";
export type Commodity = {
  id?: string;
  name?: string;
  type?: CommodityType;
  code?: string;
  user?: string;
  date?: number;
};
export type CommodityList = {
  resultsReturned?: number;
  page?: number;
  pageSize?: number;
  Items?: Commodity[];
};
export type Status = {
  value?: string;
  date?: number;
  userId?: string;
};
export type States =
  | "AL"
  | "AK"
  | "AZ"
  | "AR"
  | "CA"
  | "CO"
  | "CT"
  | "DE"
  | "DC"
  | "FL"
  | "GA"
  | "GU"
  | "HI"
  | "ID"
  | "IL"
  | "IN"
  | "IA"
  | "KS"
  | "KY"
  | "LA"
  | "ME"
  | "MD"
  | "MA"
  | "MI"
  | "MN"
  | "MS"
  | "MO"
  | "MT"
  | "NE"
  | "NV"
  | "NH"
  | "NJ"
  | "NM"
  | "NY"
  | "NC"
  | "ND"
  | "OH"
  | "OK"
  | "OR"
  | "PA"
  | "PR"
  | "RI"
  | "SC"
  | "SD"
  | "TN"
  | "TX"
  | "UT"
  | "VT"
  | "VI"
  | "VA"
  | "WA"
  | "WV"
  | "WI"
  | "WY";
export type Vehicle = {
  plateNumber?: string;
  plateState?: States;
  make?: string;
  model?: string;
  body?: string;
  color?: string;
  titleNumber?: string;
  titleState?: States;
  titleRegistration?: number;
  vin?: string;
  year?: string;
  registrationExpiration?: number;
  customerId?: string;
  isScrap?: boolean;
  inboundTicketId?: string;
};
export type Customer = {
  id?: string;
  external_id?: number;
  customerCommonIdentifierString?: string;
  companyName?: string;
  archive?: boolean;
  isSupplier?: boolean;
  isConsumer?: boolean;
  type?: "retail" | "industrial";
  vendorClass?:
    | "retail-preferred"
    | "demolition"
    | "construction"
    | "manufacturing";
  status?: Status;
  statusHistory?: Status[];
  priceSheetId?: string;
  buysForbidden?: boolean;
  notes?: string;
  locations?: {
    id?: string;
    name?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: States;
    zip?: string;
    isCorporate?: boolean;
    isShipping?: boolean;
    isPayToLocation?: boolean;
    isDefaultCorporateLocation?: boolean;
    isDefaultShippingLocation?: boolean;
    isDefaultPayToLocation?: boolean;
    primaryContactId?: string;
    notes?: string;
    freightPricing?: {
      id?: string;
      consumerFreightEnabled?: boolean;
      supplierFreightEnabled?: boolean;
      autoChargebackFlag?: boolean;
      autoApplyToInvoiceFlag?: boolean;
      consumerFreightCost?: number;
      supplierFreightCost?: number;
      locationId?: string;
    };
  }[];
  vehicles?: Vehicle[];
  contacts?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    phone1?: number;
    phone2?: number;
    email?: string;
    locationId?: string;
    role?: string;
    notes?: string;
    firstNameLegal?: string;
    lastNameLegal?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: States;
    zip?: string;
    idType?: "license";
    licenseNumber?: string;
    licenseExpiration?: number;
    licenseImage?: string;
    licenseImageBack?: string;
    height?: string;
    eyes?: string;
    gender?: string;
    hair?: string;
    image?: string;
    race?: string;
    weight?: number;
    thumbprintImage?: string;
    signatureImage?: string;
    texasCashCardAppDocspringId?: string;
    texasCashCardDocspringId?: string;
    texasCashCardId?: string;
    texasCashCardExpirationDate?: string;
    isDefaultPayToContact?: boolean;
  }[];
};
export type CustomerList = {
  resultsReturned?: number;
  page?: number;
  pageSize?: number;
  Items?: Customer[];
};
export type CustomerInvoiceList = {
  resultsReturned?: number;
  page?: number;
  pageSize?: number;
  Items?: {
    id?: string;
    status?: {
      date?: string;
      value?: string;
      userId?: string;
    };
    notes?: string;
    taxRate?: string;
    invoiceTicketId?: string;
    salesOrder?: {
      id?: string;
      salesOrderNumber?: string;
    };
    amountDue?: string;
    total?: string;
    subTotal?: string;
    outboundTicketIds?: string[];
    paymentSplits?: object[];
  }[];
};
export type GenericListResponse = {
  page: number;
  pageSize: number;
  resultsReturned?: number;
  totalResultsCount?: number;
};
export type UserListResponseItem = {
  id: string;
  firstName: string;
  lastName: string;
  active: boolean;
  email: string;
  phoneNumber?: string;
  organizationId: string;
  greensparkRole:
    | (
        | "yardAdmin"
        | "yardManager"
        | "yardEmployee"
        | "scaleOperator"
        | "driver"
        | "portalUser"
      )
    | null;
};
export type CreateGsUserRequestBody = {
  firstName: string;
  lastName: string;
  email: string;
  userGroupsAssociations: (
    | "yardAdmin"
    | "yardManager"
    | "yardEmployee"
    | "scaleOperator"
    | "driver"
    | "portalUser"
  )[];
  allowedYardNameList: string[];
  phoneNumber?: string;
  temporaryPassword?: string;
  orgModeEnabled: boolean;
  carrierId?: string;
};
export type UserDetailResponse = {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  active: boolean;
  email: string;
  phoneNumber?: string;
  organizationId: string;
  orgModeEnabled: boolean;
  carrierId?: string;
  greensparkRole:
    | (
        | "yardAdmin"
        | "yardManager"
        | "yardEmployee"
        | "scaleOperator"
        | "driver"
        | "portalUser"
      )
    | null;
  allowedYardNameList: string[];
};
export type UpdateGsUserRequestBody = {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  active?: boolean;
  allowedYardNameList?: string[];
  carrierId?: string;
  greensparkRole?:
    | "yardAdmin"
    | "yardManager"
    | "yardEmployee"
    | "scaleOperator"
    | "driver"
    | "portalUser";
};
export type ResetUserPasswordRequestBody = {
  newPassword: string;
};
export type TexasCashCardResponseDto = {
  texasCashCardAppUrl?: string;
  texasCashCardUrl?: string;
};
export type TexasCashCardRequestDto = {
  contactId?: string;
};
export type GsUserResponseBody = {
  firstName: string;
  lastName: string;
  email: string;
  userGroupsAssociations: (
    | "yardAdmin"
    | "yardManager"
    | "yardEmployee"
    | "scaleOperator"
    | "driver"
    | "portalUser"
  )[];
  organizationName: string;
  allowedYardNameList: string[];
  phoneNumber?: string;
  temporaryPassword?: string;
  orgModeEnabled: boolean;
  id: string;
  organizationId: string;
  active: boolean;
  driverDetails?: {
    id: string;
    isActive: boolean;
  };
};
export type GsPortalUserRequestBody = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  temporaryPassword?: string;
};
export type SupplierType = {
  id?: string;
  name?: string;
  active?: boolean;
};
export type SupplierTypeList = {
  resultsReturned?: number;
  page?: number;
  pageSize?: number;
  Items?: SupplierType[];
};
export type VendorClass = {
  id?: string;
  name?: string;
  active?: boolean;
};
export type VendorClassList = {
  resultsReturned?: number;
  page?: number;
  pageSize?: number;
  Items?: VendorClass[];
};
export type CustomerMaterialPurchasePriceHistory = {
  id?: string;
  yardName?: string;
  inboundTicketNumber?: number;
  inboundTicketId?: string;
  date?: string;
  materialName?: string;
  materialStatus?: {
    gross?: number;
    netWeight?: number;
    tare?: number;
    weightAndPrice?: string;
  };
};
export type CustomerMaterialPurchasePriceHistoryList = {
  totalResultsCount?: number;
  page?: number;
  pageSize?: number;
  Items?: CustomerMaterialPurchasePriceHistory[];
};
export type MaterialType = {
  id?: string;
  code?: string;
  common_name?: string;
  commodityId?: string;
  commodityName?: string;
  commodity?: Commodity;
  user?: string;
  date?: number;
  accounting_code?: string;
  accounting_expense_code?: string;
};
export type Price = {
  id?: string;
  amount?: number;
  currency?: "USD" | "BPS" | "EUR";
  precision?: number;
};
export type Note = {
  name?: string;
  value?: string;
  internal?: boolean;
  userid?: string;
  lastUpdated?: string;
};
export type FinishedGood = {
  id?: string;
  tag?: string;
  materialTypeId?: string;
  materialType?: MaterialType;
  type?: string;
  weight?: {
    gross?: number;
    net?: number;
    tare?: number;
    units?: string;
  };
  netValue?: Price;
  status?: Status;
  statusHistory?: Status[];
  notes?: Note[];
};
export type FinishedGoods = {
  page?: number;
  pageSize?: number;
  resultsReturned?: number;
  Items?: FinishedGood[];
};
export type FinishedGoodRequestDto = {
  materialTypeId?: string;
  type?: string;
  weight?: {
    gross?: number;
    net?: number;
    tare?: number;
    units?: string;
  };
  netValue?: Price;
  notes?: Note[];
};
export type CustomerSummary = {
  id?: string;
  customerCommonIdentifierString?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
};
export type Weight = {
  amount?: number;
  units?: "LBS" | "KG" | "GT" | "NT";
};
export type InboundTicketStatus = {
  value?: string;
  date?: string;
  userId?: string;
  image?: string;
  imageIsTemp?: boolean;
  tareImage?: string;
  tareImageIsTemp?: boolean;
};
export type WeightAndPrice = {
  gross?: Weight;
  tare?: Weight;
  netWeight?: Weight;
  netValue?: Price;
  netPrice?: Price;
  invoiceValue?: Price;
  um?: string;
  deductions?: {
    deductionType?: "Cost," | "Weight";
    description?: string;
    amount?: number;
    um?: "$" | "lbs" | "PER";
    notes?: string;
  }[];
};
export type MaterialStatus = {
  value?: string;
  date?: number;
  userId?: string;
  image?: string;
  imageIsTemp?: boolean;
  tareImage?: string;
  tareImageIsTemp?: boolean;
};
export type MaterialView = {
  id?: string;
  inboundTicketId?: string;
  materialTypeId?: string;
  weightAndPrice?: WeightAndPrice;
  weightAndPriceHistory?: WeightAndPrice[];
  status?: MaterialStatus;
  statusHistory?: MaterialStatus[];
};
export type Docs = {
  name?: string;
  url?: string;
  uuid?: string;
  createdAt?: string;
};
export type InboundTicketView = {
  hash?: string;
  id?: string;
  ticketId?: number;
  createdDate?: number;
  scaleType?: string;
  customer?: CustomerSummary;
  passengers?: number;
  transportationInfo?: {
    carrier?: string;
    carrierNumber?: number;
    trailerNumber?: number;
    purchaseOrderNumber?: number;
  };
  truckWeight?: {
    gross?: Weight;
    tare?: Weight;
    net?: Weight;
  };
  loadWeight?: {
    gross?: Weight;
    tare?: Weight;
    deductions?: Weight;
    net?: Weight;
  };
  netValue?: Price;
  status?: InboundTicketStatus;
  statusHistory?: InboundTicketStatus[];
  materials?: MaterialView[];
  notes?: Note[];
  scrapVehicles?: Vehicle[];
  archive?: boolean;
  contactImage?: string;
  contactImageIsTemp?: boolean;
  docs?: Docs[];
  linkedDispatchTicket?: {
    id?: string;
    externalId?: number;
  };
};
export type InboundTicketList = {
  page?: number;
  pageSize?: number;
  resultsReturned?: number;
  Items?: InboundTicketView[];
};
export type MaterialSave = {
  id?: string;
  materialTypeId?: string;
  weightAndPrice?: WeightAndPrice;
  status?: string;
  image?: string;
  imageIsTemp?: boolean;
  tareImage?: string;
  tareImageIsTemp?: boolean;
};
export type IbtFeeOrPromotion = {
  settingId: string;
  type: "FEE" | "PROMOTION";
  amount: number;
  amountType: "FLAT" | "PERCENT";
  appliedAutomatically: boolean;
  eligiblePaymentTypes: ("cash" | "check" | "eft" | "atm")[];
  name: string;
  calculatedValue?: number;
  applied?: boolean;
};
export type InboundTicketSave = {
  id?: string;
  ticketId?: number;
  createdDate?: number;
  scaleType?: string;
  customer?: CustomerSummary;
  passengers?: number;
  transportationInfo?: {
    carrier?: string;
    carrierNumber?: number;
    trailerNumber?: number;
  };
  truckWeight?: {
    gross?: Weight;
    tare?: Weight;
    net?: Weight;
  };
  loadWeight?: {
    gross?: Weight;
    tare?: Weight;
    deductions?: Weight;
    net?: Weight;
  };
  netValue?: Price;
  status?: InboundTicketStatus;
  statusHistory?: InboundTicketStatus[];
  materials?: MaterialSave[];
  notes?: Note[];
  archive?: boolean;
  contactImage?: string;
  contactImageIsTemp?: boolean;
  feeOrPromotion?: IbtFeeOrPromotion[];
};
export type InboundTicketCustomerSchema = {
  customerCommonIdentifierString?: string;
  defaultPaymentTerm?: {
    id: string;
    display: string;
    active: boolean;
    days: number;
    nonEditable: boolean;
  } | null;
  defaultPaymentTermId?: string;
  displayName?: string;
  archive: boolean;
  status?: {
    value:
      | "UNAVAILABLE"
      | "CREATED"
      | "INCOMPLETE"
      | "SCALE_COMPLETE"
      | "PRICE_COMPLETE"
      | "APPROVED"
      | "AVAILABLE"
      | "VOID"
      | "SHIPPED"
      | "UPDATED"
      | "SWIP"
      | "WIP"
      | "TEST"
      | "REGRADE"
      | "FINISHEDGOOD"
      | "OUTBOUNDTICKET"
      | "PAID"
      | "ALL"
      | "OPEN"
      | "MIGRATED"
      | "TRUCK_IN_YARD"
      | "PENDING"
      | "INVOICED";
    date: number;
    userId: string;
    grossImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    tareImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    image?: string | null;
    imageIsTemp?: boolean;
    tareImage?: string | null;
    tareImageIsTemp?: boolean;
  };
  id?: string;
  statusHistory?: {
    value:
      | "UNAVAILABLE"
      | "CREATED"
      | "INCOMPLETE"
      | "SCALE_COMPLETE"
      | "PRICE_COMPLETE"
      | "APPROVED"
      | "AVAILABLE"
      | "VOID"
      | "SHIPPED"
      | "UPDATED"
      | "SWIP"
      | "WIP"
      | "TEST"
      | "REGRADE"
      | "FINISHEDGOOD"
      | "OUTBOUNDTICKET"
      | "PAID"
      | "ALL"
      | "OPEN"
      | "MIGRATED"
      | "TRUCK_IN_YARD"
      | "PENDING"
      | "INVOICED";
    date: number;
    userId: string;
    grossImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    tareImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    image?: string | null;
    imageIsTemp?: boolean;
    tareImage?: string | null;
    tareImageIsTemp?: boolean;
  }[];
};
export type TransportationInfoSchema = {
  carrierNumber: string;
  trailerNumber: string;
  containerNumber?: string;
  isPickup?: boolean;
  driverName?: string;
  carrierName?: string | null;
  billOfLading?: string;
  purchaseOrderNumber?: number | null;
  purchaseOrderId?: string | null;
  transportationType?: "RAIL" | "TRUCK" | "BARGE" | "OTHER";
};
export type StatusWithIsotsSchema = {
  value:
    | "UNAVAILABLE"
    | "CREATED"
    | "INCOMPLETE"
    | "SCALE_COMPLETE"
    | "PRICE_COMPLETE"
    | "APPROVED"
    | "AVAILABLE"
    | "VOID"
    | "SHIPPED"
    | "UPDATED"
    | "SWIP"
    | "WIP"
    | "TEST"
    | "REGRADE"
    | "FINISHEDGOOD"
    | "OUTBOUNDTICKET"
    | "PAID"
    | "ALL"
    | "OPEN"
    | "MIGRATED"
    | "TRUCK_IN_YARD"
    | "PENDING"
    | "INVOICED";
  date?: string;
  userId?: string;
  outboundTicketId?: string;
  image?: string | null;
  imageIsTemp?: boolean;
  tareImage?: string | null;
  tareImageIsTemp?: boolean;
  grossImages?: {
    deviceId?: string;
    imageFilename?: string;
  }[];
  tareImages?: {
    deviceId?: string;
    imageFilename?: string;
  }[];
};
export type MaterialResponseItemSchema = {
  materialTypeId?: string;
  weightAndPrice?: {
    gross?: {
      amount?: number | null;
      units?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      commonString?: string;
    };
    tare?: {
      amount?: number | null;
      units?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      commonString?: string;
    } | null;
    netWeight: {
      amount?: number | null;
      units?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      commonString?: string;
    };
    deductions?: {
      id?: string;
      type?: "weight" | "cost";
      unit?: "percentage" | "pound" | "usd";
      isNew?: boolean;
      notes?: string;
      amount?: number;
      typeText?: string;
      unitText?: string;
      description?: string;
      descriptionText?: string;
    }[];
    customerPreferredUm?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
    customerPreferredPrice?: {
      amount: number;
      currency?: "USD" | "CAD" | "NZD";
      precision?: number;
      commonString?: string;
    };
    um?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
    netPrice?: {
      amount: number;
      currency?: "USD" | "CAD" | "NZD";
      precision?: number;
      commonString?: string;
    };
    netValue?: {
      amount: number;
      currency?: "USD" | "CAD" | "NZD";
      precision?: number;
      commonString?: string;
    };
    isManualGross?: boolean;
    isManualTare?: boolean;
  };
  inboundTicketId?: string;
  status?: {
    value:
      | "UNAVAILABLE"
      | "CREATED"
      | "INCOMPLETE"
      | "SCALE_COMPLETE"
      | "PRICE_COMPLETE"
      | "APPROVED"
      | "AVAILABLE"
      | "VOID"
      | "SHIPPED"
      | "UPDATED"
      | "SWIP"
      | "WIP"
      | "TEST"
      | "REGRADE"
      | "FINISHEDGOOD"
      | "OUTBOUNDTICKET"
      | "PAID"
      | "ALL"
      | "OPEN"
      | "MIGRATED"
      | "TRUCK_IN_YARD"
      | "PENDING"
      | "INVOICED";
    date: number;
    userId: string;
    grossImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    tareImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    image?: string | null;
    imageIsTemp?: boolean;
    tareImage?: string | null;
    tareImageIsTemp?: boolean;
  };
  archive?: boolean;
  materialType: {
    id?: string;
    code?: string;
    commonName: string;
    archive?: boolean;
    commodityId?: string;
    yardId?: string;
    commodity?: {
      urlName: string;
      date?: number;
      code: string;
      user?: string;
      archive: boolean;
      id: string;
      name: string;
      type: string;
      class: "OTHER" | "FERROUS" | "NON_FERROUS";
      rules?: {
        enabled: boolean;
        type: "WEIGHT_THRESHOLD";
        parameters: {
          amount: number;
        };
      }[];
    };
    commodityName?: string;
    organizationId?: string;
    date?: number;
    user?: string | null;
    isriCode?: string | null;
    notes?: string | null;
    tareWeightRequired?: boolean;
    defaultPriceEntry?: {
      id: string;
      materialTypeId: string;
      priceSheetId: string;
      materialName?: string;
      materialCode?: string;
      commodityId?: string;
      commodityName?: string;
      weightUnits: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      tareWeightRequired?: boolean;
      overrideName?: string;
      targetWeight?: number;
      fulfilledWeight?: number;
      buyPrice?: {
        id: string;
        isBuyPrice: boolean;
        price: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        priceType: string;
        minMaxRange?: number;
        differential?: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        recoveryPercentage?: number;
        otherCosts?: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        benchmarkId?: string;
        referencePriceEntryId?: string;
        sellPriceId?: string;
        buyPriceId?: string;
        user?: string;
        date?: string;
      };
      sellPrice?: {
        id: string;
        isBuyPrice: boolean;
        price: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        priceType: string;
        minMaxRange?: number;
        differential?: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        recoveryPercentage?: number;
        otherCosts?: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        benchmarkId?: string;
        referencePriceEntryId?: string;
        sellPriceId?: string;
        buyPriceId?: string;
        user?: string;
        date?: string;
      };
      description?: string;
    };
    supplementalPriceEntry?: {
      id: string;
      materialTypeId: string;
      priceSheetId: string;
      materialName?: string;
      materialCode?: string;
      commodityId?: string;
      commodityName?: string;
      weightUnits: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      tareWeightRequired?: boolean;
      overrideName?: string;
      targetWeight?: number;
      fulfilledWeight?: number;
      buyPrice?: {
        id: string;
        isBuyPrice: boolean;
        price: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        priceType: string;
        minMaxRange?: number;
        differential?: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        recoveryPercentage?: number;
        otherCosts?: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        benchmarkId?: string;
        referencePriceEntryId?: string;
        sellPriceId?: string;
        buyPriceId?: string;
        user?: string;
        date?: string;
      };
      sellPrice?: {
        id: string;
        isBuyPrice: boolean;
        price: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        priceType: string;
        minMaxRange?: number;
        differential?: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        recoveryPercentage?: number;
        otherCosts?: {
          amount: number;
          currency?: "USD" | "CAD" | "NZD";
          precision?: number;
          commonString?: string;
        };
        benchmarkId?: string;
        referencePriceEntryId?: string;
        sellPriceId?: string;
        buyPriceId?: string;
        user?: string;
        date?: string;
      };
      description?: string;
    };
    rules?: {
      type: string;
      parameters: {
        days?: number;
        paymentMethods?: string[];
      };
    }[];
    accountingCode?: string;
    accountingExpenseCode?: string | null;
    complianceOptOut?: boolean;
  };
  id?: string;
  statusHistory?: {
    value:
      | "UNAVAILABLE"
      | "CREATED"
      | "INCOMPLETE"
      | "SCALE_COMPLETE"
      | "PRICE_COMPLETE"
      | "APPROVED"
      | "AVAILABLE"
      | "VOID"
      | "SHIPPED"
      | "UPDATED"
      | "SWIP"
      | "WIP"
      | "TEST"
      | "REGRADE"
      | "FINISHEDGOOD"
      | "OUTBOUNDTICKET"
      | "PAID"
      | "ALL"
      | "OPEN"
      | "MIGRATED"
      | "TRUCK_IN_YARD"
      | "PENDING"
      | "INVOICED";
    date: number;
    userId: string;
    grossImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    tareImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    image?: string | null;
    imageIsTemp?: boolean;
    tareImage?: string | null;
    tareImageIsTemp?: boolean;
  }[];
  weightAndPriceHistory?: {
    gross?: {
      amount?: number | null;
      units?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      commonString?: string;
    };
    tare?: {
      amount?: number | null;
      units?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      commonString?: string;
    } | null;
    netWeight: {
      amount?: number | null;
      units?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      commonString?: string;
    };
    deductions?: {
      id?: string;
      type?: "weight" | "cost";
      unit?: "percentage" | "pound" | "usd";
      isNew?: boolean;
      notes?: string;
      amount?: number;
      typeText?: string;
      unitText?: string;
      description?: string;
      descriptionText?: string;
    }[];
    customerPreferredUm?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
    customerPreferredPrice?: {
      amount: number;
      currency?: "USD" | "CAD" | "NZD";
      precision?: number;
      commonString?: string;
    };
    um?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
    netPrice?: {
      amount: number;
      currency?: "USD" | "CAD" | "NZD";
      precision?: number;
      commonString?: string;
    };
    netValue?: {
      amount: number;
      currency?: "USD" | "CAD" | "NZD";
      precision?: number;
      commonString?: string;
    };
    isManualGross?: boolean;
    isManualTare?: boolean;
  }[];
  rowIndex?: number | null;
  transferTag?: string | null;
  axleWeights?: {
    id?: string;
    gross?: number;
    grossImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    isManualGross?: boolean;
    tare?: number;
    tareImages?: {
      deviceId?: string;
      imageFilename?: string;
    }[];
    isManualTare?: boolean;
    axleNumber: number;
  }[];
  orderEntryId: string | null;
  materialOverrideName?: string;
  finishedGood?: {
    id: string;
    itemCount?: number;
    tag: string;
  };
};
export type VehicleInfoSchema = {
  id?: string;
  vin?: string;
  year?: string;
  make?: string;
  model?: string;
  color?: string;
  body?: string;
  titleNumber?: string;
  plateNumber?: string;
  registrationExpiration?: string | null;
  titleState?: string;
  plateState?: string;
  customerId?: string | null;
  isScrap?: boolean;
  inboundTicketId?: string;
  rowIndex?: number;
};
export type YardSchemaBase = {
  id?: string;
  organizationId: string;
  locationId?: string;
  name: string;
  archive: boolean;
  settings?: {
    [key: string]: any;
  };
  hasAtm: boolean;
  addressName: string;
  address: string;
  address2: string | null;
  city: string;
  state: string;
  zip: string;
  defaultCurrency: "USD" | "CAD" | "NZD";
  defaultUOM: string;
  defaultTimezone?: string;
  phoneNumber?: string | null;
};
export type BenchmarkHistory = {
  date?: number;
  price?: number;
  currency?: string;
  units?: string;
  userId?: string;
};
export type Benchmark = {
  id?: string;
  name?: string;
  publication?: string;
  archive?: boolean;
  price?: Price;
  units?: string;
  history?: BenchmarkHistory[];
};
export type PriceEntryDetail = {
  id?: string;
  isBuyPrice?: boolean;
  price?: Price;
  priceType?: string;
  minMaxRange?: number;
  differential?: Price;
  recoveryPercentage?: number;
  otherCosts?: Price;
  benchmarkId?: string;
  benchmark?: Benchmark;
  sellPriceId?: string;
  buyPriceId?: string;
  user?: string;
  date?: number;
  description?: string;
};
export type PriceEntry = {
  id?: string;
  materialTypeId?: string;
  priceSheetId?: string;
  materialName?: string;
  materialCode?: string;
  overrideName?: string;
  description?: string;
  buyPrice?: PriceEntryDetail;
  sellPrice?: PriceEntryDetail;
  targetWeight?: number;
  weightUnits?: "LBS" | "KG" | "GTON" | "NTON";
};
export type BillSchema = {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  completionDate?: string;
  archivedAt?: string;
  status?: string;
  netCost?: number;
  taxRate?: number;
  appliedRoundingDelta?: string;
  paymentMethods?: {
    paymentMethod:
      | "cash"
      | "check"
      | "eft"
      | "other cash drawer activity"
      | "atm"
      | "gs_pay";
    roundingDelta: string;
    feesOrPromotionsTotal?: string;
    netCostAndFeesOrPromotions?: string;
    netCost?: string;
    isRestricted: boolean;
  }[];
  total?: number;
  balance?: number;
  isMultiTicket?: boolean;
  externalId?: number;
  numberOfTickets?: number;
  customerId?: string;
  customerDisplayName?: string;
  inboundTicketIds?: string[];
  outboundTicketIds?: string[];
  paymentIds?: string[];
  notes?: string;
  currency?: string;
  foreignCurrency?: string;
  type?: "MATERIAL" | "FREIGHT";
  effectiveDate?: string;
  yardId?: string;
  yard?: YardSchemaBase;
  priceEntriesByPurchaseOrderId?: {
    [key: string]: PriceEntry[];
  };
};
export type FreightCostSchema = {
  id?: string;
  cost?: number;
  chargeBack?: number;
  userChargebackSet: boolean;
  userSet: boolean;
  freightBillId?: string | null;
  freightBill?: {
    id?: string;
    createdAt?: string;
    updatedAt?: string;
    completionDate?: string;
    archivedAt?: string;
    status?: string;
    netCost?: number;
    taxRate?: number;
    appliedRoundingDelta?: string;
    paymentMethods?: {
      paymentMethod:
        | "cash"
        | "check"
        | "eft"
        | "other cash drawer activity"
        | "atm"
        | "gs_pay";
      roundingDelta: string;
      feesOrPromotionsTotal?: string;
      netCostAndFeesOrPromotions?: string;
      netCost?: string;
      isRestricted: boolean;
    }[];
    total?: number;
    balance?: number;
    isMultiTicket?: boolean;
    externalId?: number;
    numberOfTickets?: number;
    customerId?: string;
    customerDisplayName?: string;
    inboundTicketIds?: string[];
    outboundTicketIds?: string[];
    paymentIds?: string[];
    notes?: string;
    currency?: string;
    foreignCurrency?: string;
    type?: "MATERIAL" | "FREIGHT";
    effectiveDate?: string;
    yardId?: string;
    yard?: YardSchemaBase;
  };
};
export type AxleWeightSchema = {
  id?: string;
  gross?: number;
  grossImages?: {
    deviceId?: string;
    imageFilename?: string;
  }[];
  isManualGross?: boolean;
  tare?: number;
  tareImages?: {
    deviceId?: string;
    imageFilename?: string;
  }[];
  isManualTare?: boolean;
  axleNumber: number;
};
export type FeeOrPromotionSchema = {
  settingId: string;
  amount?: number;
  type: "FEE" | "PROMOTION";
  amountType: "FLAT" | "PERCENT";
  appliedAutomatically: boolean;
  eligiblePaymentTypes: ("cash" | "check" | "eft" | "atm")[];
  name: string;
};
export type InboundTicketResponseItem = {
  customer: InboundTicketCustomerSchema;
  createdDate: string;
  createdById?: string;
  effectiveDate: string;
  numberOfPassengers?: string | null;
  transportationInfo: TransportationInfoSchema;
  truckWeight: {
    gross: {
      amount?: number | null;
      units?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      commonString?: string;
    };
    tare: {
      amount?: number | null;
      units?: "lbs" | "kg" | "gt" | "nt" | "mt" | "cwt" | "ea";
      commonString?: string;
    };
    isManualGross?: boolean;
    isManualTare?: boolean;
  };
  status?: StatusWithIsotsSchema;
  loadWeight: {
    gross?: number;
    tare?: number | null;
    deductions?: number;
    net?: number;
  };
  netWeight: number;
  netPrice: {
    amount: number;
    currency?: "USD" | "CAD" | "NZD";
    precision?: number;
    commonString?: string;
  };
  netValue: {
    amount: number;
    currency?: "USD" | "CAD" | "NZD";
    precision?: number;
    commonString?: string;
  };
  notes?: {
    id?: string;
    name: string;
    internal?: boolean;
    date?: string;
    userId?: string;
  }[];
  materials?: MaterialResponseItemSchema[];
  id: string;
  ticketId: number;
  archive: boolean;
  statusHistory?: StatusWithIsotsSchema[];
  paymentId?: string | null;
  scrapVehicles?: VehicleInfoSchema[];
  taxRate?: string | null;
  roundingDelta?: string | null;
  vehicleId?: string | null;
  locationId?: string | null;
  contactId?: string | null;
  address: {
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
  } | null;
  billId?: string;
  ticketType?: ("INBOUND" | "OUTBOUND" | "TRANSFER") | null;
  transferredFromObtId?: string | null;
  docs?: {
    name: string;
    url: string;
    uuid: string;
    createdAt: string;
  }[];
  bill?: BillSchema;
  contactImage?: string | null;
  contactImageIsTemp?: boolean;
  carrierId?: string | null;
  freightLanePriceId?: string;
  gridImage?: string | null;
  materialTypeCommonNames?: string[];
  freightCost?: FreightCostSchema;
  hash?: string;
  axleWeights?: AxleWeightSchema[];
  linkedDispatchTicket?: {
    id: string;
    externalId: number;
  };
  yardId?: string;
  yard?: YardSchemaBase;
  feeOrPromotion?: FeeOrPromotionSchema[];
  feeOrPromotionTotal: number;
};
export type QueuePaymentList = {
  materialTypeId?: string;
  materialTypeCommonName?: string;
  totalAmount?: number;
  count?: number;
  isRestricted?: boolean;
  rules?: {
    type?: string;
    parameters?: object;
  }[];
}[];
export type MaterialTypeList = {
  page?: number;
  pageSize?: number;
  resultsReturned?: number;
  Items?: MaterialType[];
};
export type FinishedGoodWithWeight = {
  id?: string;
  weight?: {
    gross?: number;
    net?: number;
    tare?: number;
    units?: string;
  };
};
export type OutboundTicketPackingListDto = {
  id?: string;
  finishedGoods?: FinishedGoodWithWeight[];
};
export type OutboundTicketMaterialWeights = {
  materialTypeId?: string;
  weight?: number;
  gross?: number;
  tare?: number;
}[];
export type OutboundTicket = {
  id?: string;
  status?: "AVAILABLE" | "SHIPPED" | "VOID";
  userId?: string;
  date?: number;
  customerId?: string;
  netWeight?: number;
  transportationInfo?: {
    carrier?: string;
    carrierNumber?: number;
    trailerNumber?: number;
  };
  shippingInfo?: {
    locationId?: string;
    address?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
  invoiceId?: string;
  linkedDispatchTicket?: {
    id?: string;
    externalId?: number;
  };
  packingLists?: OutboundTicketPackingListDto[];
  finishedGoods?: FinishedGoodWithWeight[];
  materialWeights?: OutboundTicketMaterialWeights;
  docs?: Docs[];
};
export type OutboundTicketRequestDto = {
  customerId?: string;
  packingLists?: OutboundTicketPackingListDto;
  finishedGoods?: FinishedGoodWithWeight[];
  materialWeights?: OutboundTicketMaterialWeights;
  transportationInfo?: {
    carrier?: string;
    carrierNumber?: number;
    trailerNumber?: number;
  };
  shippingInfo?: {
    locationId?: string;
    address?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
  status?: "INCOMPLETE" | "SHIPPED" | "VOID";
};
export type OutboundTicketResponseDto = {
  count?: number;
  Items?: OutboundTicket[];
};
export type PackingList = {
  id?: string;
  tag?: string;
  status?: "AVAILABLE" | "SHIPPED";
  finishedGoodsIds?: string[];
  createdDate?: number;
  updatedDate?: number;
  finishedGoods?: {
    finishedGoodId?: string;
    materialType?: MaterialType;
  }[];
};
export type PackingLists = {
  Items?: PackingList[];
};
export type PackingListRequestDto = {
  status?: "AVAILABLE" | "SHIPPED";
  finishedGoodsIds?: string[];
};
export type InventoryAdjustmentMaterial = {
  id?: string;
  netCost?: number;
  netWeight?: number;
  materialTypeId?: string;
  materialType?: MaterialType;
  createdAt?: string;
  updatedAt?: string;
};
export type InventoryAdjustment = {
  id?: string;
  externalId?: number;
  notes?: string;
  type?: string;
  effectiveDate?: string;
  createdAt?: string;
  updatedAt?: string;
  materials?: InventoryAdjustmentMaterial[];
};
export type InventoryAdjustmentsList = {
  resultsReturned?: number;
  totalResultsCount?: number;
  page?: number;
  pageSize?: number;
  Items?: InventoryAdjustment[];
};
export type PriceSheet = {
  id?: string;
  type?:
    | "DEFAULT"
    | "PREFERRED"
    | "COMMERICAL"
    | "RETAIL"
    | "CUSTOMER_SPECIFIC";
  baseName?: string;
  entriesObj?: PriceEntry[];
  status?: Status;
  statusHistory?: Status[];
  archive?: boolean;
};
export type PriceSheetList = {
  page?: number;
  pageSize?: number;
  resultsReturned?: number;
  Items?: PriceSheet[];
};
export type MergeIbtsRequest = string[];
export type MaterialTypeAndWeightDto = {
  materialType?: object;
  materialTypeId?: string;
  weight?: number;
};
export type RegradeResponseDto = {
  id?: string;
  date?: number;
  userId?: string;
  fromMaterial?: MaterialTypeAndWeightDto;
  toMaterials?: MaterialTypeAndWeightDto[];
  fromMaterialIds?: string[];
  toMaterialIds?: string[];
  notes?: string;
};
export type Regrades = {
  id?: string;
  Items?: RegradeResponseDto[];
};
export type RegradeDto = {
  id?: string;
  fromMaterial?: MaterialTypeAndWeightDto;
  toMaterials?: MaterialTypeAndWeightDto[];
  notes?: Note[];
  effectiveDate?: string;
};
export type CommoditiesInventorySummary = {
  resultsReturned?: number;
  page?: number;
  pageSize?: number;
  totalWeight?: Weight;
  totalCost?: Price;
  largestMaterialByWeight?: string;
  largestMaterialByValue?: string;
  weightReceivedYesterday?: Weight;
  weightShippedYesterday?: Weight;
  Items?: {
    name?: string;
    wip?: Weight;
    wipCost?: Price;
    finishedGoods?: Weight;
    finishedGoodCost?: Price;
    totalWeight?: Weight;
    avgCost?: Price;
    value?: Price;
  }[];
};
export type CommoditySummary = {
  id?: string;
  name?: string;
};
export type MaterialTypeSummary = {
  materialTypeId?: string;
  materialTypeName?: string;
  materialTypeCode?: string;
  wip?: Weight;
  wipCost?: Price;
  wipAvgCost?: Price;
  finishedGoods?: Weight;
  finishedGoodCost?: Price;
  finishedGoodAvgCost?: Price;
  totalWeight?: Weight;
  averageCost?: Price;
  value?: Price;
};
export type CommodityInventoryDetail = {
  resultsReturned?: number;
  page?: number;
  pageSize?: number;
  wipWeight?: Weight;
  wipCost?: Price;
  finishedGoodWeight?: Weight;
  finishedGoodCost?: Price;
  largestMaterialByWeight?: string;
  largestMaterialByValue?: string;
  weightReceivedYesterday?: Weight;
  weightShippedYesterday?: Weight;
  commodity?: CommoditySummary;
  Items?: MaterialTypeSummary[];
};
export type WeightAndCount = {
  count?: number;
  weight?: Weight;
  commonString?: string;
};
export type FinishedGoodSummary = {
  id?: string;
  tag?: string;
  materialTypeId?: string;
  materialTypeName?: string;
  materialTypeCode?: string;
  commodityName?: string;
  materials?: string[];
  type?: string;
  weight?: {
    gross?: number;
    net?: number;
    tare?: number;
    units?: string;
  };
  netValue?: Price;
  status?: Status;
  statusHistory?: Status[];
  notes?: Note[];
};
export type InventoryFinishedGoodList = {
  resultsReturned?: number;
  page?: number;
  pageSize?: number;
  finishedGoodsAvailable?: WeightAndCount;
  finishedGoodsTotal?: WeightAndCount;
  createdToday?: number;
  createdYesterday?: number;
  largestFinishedGoodMaterialByWeight?: string;
  Items?: FinishedGoodSummary[];
};
export type InventoryRegradeMeta = {
  resultsReturned?: number;
  totalRegrades30Days?: number;
  regradedToday?: number;
  largestRegradedMaterialByWeight?: string;
  totalValueGained?: Price;
};
export type InventoryPackingListMeta = {
  resultsReturned?: number;
  packingListsAvailable?: WeightAndCount;
  packingListsTotal?: WeightAndCount;
  createdToday?: number;
  createdYesterday?: number;
  largestMaterialByWeight?: string;
};
export type InventoryMaterialType = {
  id?: string;
  effectiveDate?: string;
  materialTypeId?: string;
  materialTypeCode?: string;
  materialTypeName?: string;
  wipCost?: Price;
  wipAvgCost?: Price;
  wip?: Weight;
};
export type YardResponseSchema = {
  id: string;
  organizationId: string;
  defaultLocationId?: string;
  locationId?: string;
  name: string;
  archive: boolean;
  organization?: any;
  settings: {
    [key: string]: any;
  };
  hasAtm: boolean;
  addressName: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  defaultCurrency: "USD" | "CAD" | "NZD";
  defaultUOM: string;
  defaultTimezone?: string;
  phoneNumber?: string;
  gsPayEnabled: boolean;
  customerId?: string;
  locale: "en-US" | "en-CA" | "en-NZ";
};
export type OrganizationResponseSchema = {
  id: string;
  name: string;
  logo?: string;
  archive?: boolean;
  defaultTimezone?: string;
  taxId?: string;
  yards?: YardResponseSchema[];
};
export type BenchmarkList = {
  page?: number;
  pageSize?: number;
  resultsReturned?: number;
  Items?: Benchmark[];
};
export type PriceEntryList = {
  page?: number;
  pageSize?: number;
  resultsReturned?: number;
  Items?: PriceEntry[];
};
export type PriceEntryHistory = {
  id?: string;
  yardId?: string;
  priceEntryId?: string;
  newPrice?: number;
  newPriceCurrency?: string;
  oldPrice?: number;
  oldPriceCurrency?: string;
  date?: string;
  userId?: string;
}[];
export type PaymentTerm = {
  id?: string;
  active?: boolean;
  days?: number;
  display?: string;
  nonEditable?: boolean;
};
export type Yard = {
  id?: string;
  name?: string;
};
export type SalesOrderDetails = {
  id?: string;
  effectiveDate?: number;
  expirationDate?: number;
  fairOnBoard?: string;
  packageType?: string;
  pickupDelivery?: string;
  departingYard?: string;
  invoiceWeights?: string;
};
export type SalesOrder = {
  id?: string;
  salesOrderTicketId?: number;
  paymentTerm?: PaymentTerm;
  paymentTermId?: string;
  paymentMethod?: string;
  paymentOptions?: string;
  fulfilledAmount?: number;
  status?: string;
  notes?: string;
  customerId?: string;
  customerPONumber?: string;
  salesOrderLocationId?: string;
  orderSalesId?: string;
  priceSheetId?: string;
  yardId?: string;
  yard?: Yard;
  isExport?: boolean;
  orderSalesDetails?: SalesOrderDetails;
  docs?: Docs[];
};
export type SalesOrderList = SalesOrder[];
export type SalesOrderCreation = {
  paymentTermId?: string;
  paymentMethod?: string;
  paymentOptions?: string;
  fulfilledAmount?: number;
  status?: string;
  notes?: string;
  customerId?: string;
  customerPONumber?: string;
  salesOrderLocationId?: string;
  priceSheetId?: string;
  isExport?: boolean;
  orderSales?: SalesOrderDetails;
  docs?: Docs[];
};
export type PurchaseOrderDetails = {
  id?: string;
  effectiveDate?: number;
  expirationDate?: number;
  packageType?: string;
  pickupDelivery?: string;
  receivingYard?: string;
};
export type PurchaseOrder = {
  id?: string;
  purchaseOrderTicketId?: number;
  paymentTerm?: PaymentTerm;
  paymentTermId?: string;
  paymentMethod?: string;
  paymentOptions?: string;
  fulfilledAmount?: number;
  status?: string;
  notes?: string;
  supplierId?: string;
  customerSONumber?: string;
  purchaseOrderLocationId?: string;
  orderId?: string;
  priceSheetId?: string;
  yardId?: string;
  yard?: Yard;
  order?: PurchaseOrderDetails;
  docs?: Docs[];
};
export type PurchaseOrderList = PurchaseOrder[];
export type PurchaseOrderCreation = {
  paymentTermId?: string;
  paymentMethod?: string;
  paymentOptions?: string;
  fulfilledAmount?: number;
  status?: string;
  notes?: string;
  supplierId?: string;
  customerSONumber?: string;
  purchaseOrderLocationId?: string;
  priceSheetId?: string;
  order?: PurchaseOrderDetails;
  docs?: Docs[];
};
export type InvoiceBulkPaymentResponse = {
  id?: string;
};
export type InvoiceBulkPaymentCreation = {
  paymentDate: string;
  paymentType: "CASH" | "CHECK" | "CREDIT_CARD" | "WIRE" | "ACH" | "OTHER";
  checkNumber?: string;
  amountPaid: number;
  currency: "USD" | "CAD" | "NZD";
  notes?: string;
  paymentSplits: {
    targetInvoiceId?: string;
    amount?: string;
    adjustment?: string;
    notes?: string;
  }[];
};
export type InvoiceListResponse = {
  id: string | null;
  invoiceTicketId: number;
  status: string;
  total: number;
  customerDisplayName: string;
  issueDate: string;
  dueDate: string;
  currency: "USD" | "CAD" | "NZD";
  customerId: string;
  salesOrderId?: string | null;
  salesOrderTicketId: number | null;
  orders?: {
    id: string;
    number: number;
    type: "SALES_ORDER" | "PURCHASE_ORDER";
  }[];
  tickets?: {
    id: string;
    tag: string;
    type: "INBOUND" | "OUTBOUND";
  }[];
  outboundTicketIds: string[];
  outboundTicketTags?: number[];
  materialTypeCommonNames?: string[];
};
export type InvoiceResponseV2 = {
  id: string | null;
  total: number;
  taxRate?: string;
  subTotal: string;
  notes?: string | null;
  invoiceTicketId: number;
  status: {
    value: string;
    date: string;
    userId: string;
  };
  userId: string;
  issueDate?: string;
  consumerWeights?: {
    id: string;
    createdAt: string;
    updatedAt: string;
    materialTypeId: string;
    um?: string;
    consumerNetWeight: number;
    consumerGross: number;
    consumerTare: number;
    consumerPrice: number;
    outboundTicketId: string;
  }[];
  usingConsumerWeights: boolean;
  lockConsumerWeights: boolean;
  salesOrderId: string;
  outboundTicketIds: string[];
  currency: "USD" | "CAD" | "NZD";
  customerId: string;
};
export type InvoiceRequestBody = {
  id?: string | null;
  total?: number | null;
  status: {
    value: "OPEN" | "CLOSED" | "VOID" | "PAID";
  };
  notes?: string | null;
  salesOrderId: string;
  issueDate: number;
  outboundTickets: string[];
  invoiceTicketId?: number | null;
  consumerWeights?: {
    id: string;
    outboundTicketId: string;
    materialTypeId: string;
    consumerNetWeight: number;
    consumerGross: number;
    consumerTare: number;
    consumerPrice: number;
    um?: string;
  }[];
  usingConsumerWeights?: boolean;
};
export type MaterialPriceWeightSchema = {
  grossWeight: number;
  tareWeight: number;
  netWeight: number;
  looseMaterialNetWeight: number;
  itemCount: number;
  unitOfWeight: string;
  pricePerUnit: number;
  priceWeightUnit: string;
  total: number;
};
export type MaterialPriceWeightWithAdjustmentSchema =
  MaterialPriceWeightSchema & {
    netWeightBeforeAdjustments: number;
    netWeightAdjustment: number;
    valueBeforeAdjustments: number;
    valueAdjustment: number;
    invoiceValue?: number;
    adjustments: {
      id?: string;
      type?: "weight" | "cost";
      unit?: "percentage" | "absolute" | "pound" | "usd";
      isNew?: boolean;
      notes?: string;
      amount?: number;
      typeText?: string;
      unitText?: string;
      description?: string;
      descriptionText?: string;
    }[];
  };
export type InvoiceTicketResponseDtoSchema = {
  id: string;
  tag: string;
  millScaleNumber: string;
  bookingRefNumber: string;
  containerNumber: string;
  status: string;
  freightChargeback: number;
  feesOrPromotions: {
    name: string;
    amount: number;
    type: "FEE" | "PROMOTION";
    calculatedValue: number;
  }[];
  materials: {
    ticketId: string;
    materialTypeId: string;
    orderEntryId: string;
    materialName: string;
    materialOverrideName: string | null;
    consumerOverrideName: string | null;
    materialCode: string;
    yardPriceWeight: MaterialPriceWeightWithAdjustmentSchema;
    consumerPriceWeight: MaterialPriceWeightWithAdjustmentSchema;
  }[];
};
export type InvoicePaymentResponseDtoSchema = {
  id: string;
  date: string;
  method: string;
  checkNumber: string;
  amount: number;
  adjustments: number;
  notes: string;
  isBulkPayment: boolean;
};
export type InvoiceSummaryResponseDtoSchema = {
  grossTotal: number;
  tareTotal: number;
  netTotal: number;
  subtotal: number;
  tax: number;
  total: number;
};
export type InvoiceResponseV3 = {
  id: string;
  invoiceTicketId: number;
  sourceType: "INBOUND" | "OUTBOUND";
  currency: "USD" | "CAD" | "NZD";
  details: {
    salesOrderId?: string | null;
    salesOrderNumber: string | null;
    defaultPaymentMethod: string | null;
    paymentTerm: string;
    paymentTermId: string;
    issueDate: string;
    dueDate: string;
    customer: {
      id: string;
      displayName: string;
    };
  };
  tickets: InvoiceTicketResponseDtoSchema[];
  paymentSplits: InvoicePaymentResponseDtoSchema[];
  balance: number;
  amountPaid: number;
  status: string;
  taxRate?: number;
  notes: string;
  usingConsumerWeights: boolean;
  consumerSummary: InvoiceSummaryResponseDtoSchema;
  yardSummary: InvoiceSummaryResponseDtoSchema;
  freight: number;
  lockConsumerWeights: boolean;
  foreignExchangeRate?: number | null;
  customForeignExchangeRateEnabled: boolean;
  /** For backwards compatibility */
  salesOrderId?: string | null;
  /** For backwards compatibility */
  salesOrder?: {
    id: string;
    salesOrderNumber: string | null;
    defaultPaymentMethod: string | null;
    paymentTerm: string;
    paymentTermId: string;
    issueDate: string;
    dueDate: string;
    customer: {
      id: string;
      displayName: string;
    };
  } | null;
  /** For backwards compatibility */
  outboundTickets?: InvoiceTicketResponseDtoSchema[];
};
export type InvoiceInboundRequestBody = {
  total?: number | null;
  status: {
    value: "OPEN" | "CLOSED" | "VOID" | "PAID";
  };
  notes?: string | null;
  billId: string | null;
  paymentTermId?: string | null;
  paymentMethod?: string | null;
  issueDate: number;
  invoiceTicketId?: number | null;
  foreignExchangeRate?: number | null;
  customForeignExchangeRateEnabled: boolean;
};
export type InvoicePaymentResponse = {
  id?: string;
  userId?: string;
  yardId?: string;
  paymentNumber?: string;
  paymentDate?: string;
  createdAt?: string;
  updatedAt?: string;
  paymentType?: string;
  checkNumber?: string;
  notes?: string;
  paymentSplits?: {
    id?: string;
    targetInvoiceId?: string;
    targetInvoiceNumber?: string;
    sourcePaymentId?: string;
    amountDueWhenPaid?: string;
    amount?: string;
    adjustment?: string;
    notes?: string;
  }[];
  amount?: string;
  customerName?: string;
  customerId?: string;
};
export type Device = {
  id?: string;
  type?: string;
  name?: string;
  description?: string;
  gateway?: string;
  deviceId?: string;
};
export type ImageSavedResponse = {
  imageName?: string;
};
export type Bill = {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  effectiveDate?: string;
  completionDate?: string;
  archivedAt?: string;
  status?: string;
  netCost?: number;
  taxRate?: number;
  paymentMethods?: {
    paymentMethod:
      | "cash"
      | "check"
      | "eft"
      | "other cash drawer activity"
      | "atm"
      | "gs_pay";
    roundingDelta: string;
    feesOrPromotionsTotal?: string;
    netCostAndFeesOrPromotions?: string;
    netCost?: string;
    isRestricted: boolean;
  }[];
  total?: number;
  feeOrPromotionTotal?: number;
  balance?: number;
  appliedRoundingDelta?: string;
  isMultiTicket?: boolean;
  externalId?: number;
  numberOfTickets?: number;
  customerId?: string;
  customerDisplayName?: string;
  customerPreferredPaymentMethod?: string;
  inboundTicketIds?: string[];
  outboundTicketIds?: string[];
  paymentIds?: string[];
  notes?: string;
  currency?: string;
  foreignCurrency?: string;
  type?: "MATERIAL" | "FREIGHT";
  yardId?: string;
  yard?: YardSchemaBase;
};
export type Payment = {
  id?: string;
  paymentDate?: number;
  completionDate?: number;
  paymentMethod?: string;
  paymentNumber?: string;
  status?: string;
  total?: number;
  paymentNotes?: string;
  purchaseOrderId?: string;
  purchaseOrder?: PurchaseOrder;
  inboundTickets?: InboundTicketView;
  yard?: Yard;
  yardId?: string;
  createdAt?: number;
  updatedAt?: number;
  deletedAt?: number;
  accountId?: string;
  checkMemo?: string;
};
export type PaymentList = Payment[];
export type PaymentCreation = {
  paymentDate?: number;
  completionDate?: number;
  paymentMethod?: string;
  paymentNumber?: string;
  purchaseOrderId?: string;
  paymentNotes?: string;
  total?: number;
  status?: string;
};
export type ErpSyncBatch = {
  userName?: string;
  dateTime: string;
  batchNumber: string;
  status:
    | "SYNC_COMPLETED"
    | "SYNC_FAILED"
    | "SYNC_PARTIALLY_COMPLETE"
    | "IN_PROGRESS";
  perYardBatchNumber: string;
  syncStatus?: {
    id: string;
    itemType: string;
    createdDateTime: string;
    status?: string;
    customerCommonIdentifierString?: string;
    value?: number;
    currency?: "USD" | "CAD" | "NZD";
    externalId?: string;
    entityId?: string;
    billId?: string;
    inboundTicketId?: string;
    userFacingErrorMsg?: string;
  }[];
};
export type Role = {
  roleName?: string;
  permissions?: string[];
};
export type PricePermissions = {
  priceRead?: boolean;
  priceWrite?: boolean;
};
export type Permissions = {
  roles?: Role[];
  viewPermissions?: {
    inboundTicket?: PricePermissions;
    commodities?: PricePermissions;
    inventory?: PricePermissions;
  };
};
export type IdScanResponse = {
  ParseImageResult?: {
    Confidence?: number;
    DriverLicense?: {
      Address1?: string;
      Address2?: string;
      Birthdate?: string;
      CardRevisionDate?: string;
      City?: string;
      ClassificationCode?: string;
      ComplianceType?: string;
      Country?: string;
      CountryCode?: string;
      DocumentType?: string;
      EndorsementCodeDescription?: string;
      EndorsementsCode?: string;
      ExpirationDate?: string;
      EyeColor?: string;
      FirstName?: string;
      FullName?: string;
      Gender?: string;
      HAZMATExpDate?: string;
      HairColor?: string;
      IIN?: string;
      IssueDate?: string;
      IssuedBy?: string;
      JurisdictionCode?: string;
      LastName?: string;
      LicenseNumber?: string;
      MiddleName?: string;
      NamePrefix?: string;
      NameSuffix?: string;
      OrganDonor?: string;
      PostalBox?: string;
      PostalCode?: string;
      Race?: string;
      RestrictionCode?: string;
      RestrictionCodeDescription?: string;
      VehicleClassCode?: string;
      VehicleClassCodeDescription?: string;
      Veteran?: string;
      WeightKG?: string;
      WeightLBS?: string;
    };
  };
};
export type VinDecoderResponse = {
  message?: {
    code?: number;
    message?: string;
    credentials?: string;
    version?: string;
    endpoint?: string;
    counter?: number;
  };
  data?: {
    year?: number;
    make?: string;
    model?: string;
    manufacturer?: string;
    engine?: string;
    trim?: string;
    transmission?: string;
  };
};
export type InvoicePayment = {
  id?: string;
  invoiceId?: string;
  paymentId?: string;
  paymentDate?: string;
  checkNumber?: string;
  amountPaid?: number;
  paymentType?: string;
  notes?: string;
};
export type InvoicePaymentsResponse = {
  Items?: InvoicePayment[];
};
export type InvoicePaymentRequest = {
  invoiceId?: string;
  paymentId?: string;
  paymentDate?: string;
  checkNumber?: string;
  amountPaid?: number;
  paymentType?: string;
  notes?: string;
};
export type RbacSettingList = {
  id: string;
  route: string;
  allow: boolean;
  children: any;
  displayName: string;
}[];
export type AdminRbacSettings = {
  yardManager: RbacSettingList;
  scaleOperator: RbacSettingList;
  yardEmployee: RbacSettingList;
  driver: RbacSettingList;
};
export type AdminSettings = {
  rbac: AdminRbacSettings;
};
export type FeeOrPromotionSettingResponseBody = {
  name: string;
  type: "FEE" | "PROMOTION";
  amount?: number;
  amountType: "FLAT" | "PERCENT";
  eligiblePaymentTypes: ("cash" | "check" | "eft" | "atm")[];
  id: string;
  isPayMethodSpecific: boolean;
  isActive: boolean;
};
export type FeeOrPromotionSettingBody = {
  name: string;
  type: "FEE" | "PROMOTION";
  amount?: number;
  amountType: "FLAT" | "PERCENT";
  eligiblePaymentTypes: ("cash" | "check" | "eft" | "atm")[];
};
export type UpdateFeeOrPromotionSettingBody = {
  name: string;
  type: "FEE" | "PROMOTION";
  amount?: number;
  amountType: "FLAT" | "PERCENT";
  eligiblePaymentTypes: ("cash" | "check" | "eft" | "atm")[];
  isActive: boolean;
};
export type VehicleList = Vehicle[];
export type SaveGsPayVendorResponse = {
  externalVendorId: number;
};
export type SaveGsPayVendorRequest = {
  contactId: string;
};
export type BatchBillResponseBody = {
  id: string;
  status: string;
  startingCheckNumber?: string;
  paymentMethod: string;
  currency: string;
  createdAt: string;
  updatedAt: string;
  paymentDate?: string;
  completionDate?: string;
  idempotencyKey?: string;
  billTotal?: number;
  paymentsTotal?: number;
  bills?: Bill[];
  externalId: string;
  notes?: string;
};
export type BatchBillListResponse = {
  Items: BatchBillResponseBody[];
};
export type BatchBillRequestBody = {
  bills?: {
    billId?: string;
    inboundTicketIds?: string[];
  }[];
  idempotencyKey?: string;
  startingCheckNumber?: string;
  paymentMethod?: string;
  currency?: string;
  notes?: string;
  paymentDate?: string;
  completionDate?: string;
};
export type LockAccountingPeriodSchema = {
  isLockedForAccounting: boolean;
  lockAccountingDate?: string;
};
export type LockedEntitySchema = {
  entityId: string;
  type: string;
  yardId?: string;
  displayId: string;
  status: string;
};
export type PaymentTermList = PaymentTerm[];
export type AssetResponseSchema = {
  id: string;
  assetName: string;
  assetCategory: "CONTAINER" | "TRUCK" | "TRAILER";
  assetTypeId: string;
  type: string;
  notes?: string;
  assetStatus?: {
    id?: string;
    status?: "DEPLOYED" | "IN_PROGRESS" | "INVENTORY" | "FAILED";
    fromLocationId?: string;
    fromLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    toLocationId?: string;
    toLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    currentLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    dispatchTicketId?: string;
    assetId?: string;
    asset?: any;
    note?: string;
    completionNote?: string;
    createdAt?: string;
    effectiveDate?: string;
  };
  make?: string;
  model?: string;
  plateNumber?: string;
  plateState?: string;
  totalTrips?: number;
  daysOnSite?: string;
  dispatchTicketStatus?: string;
};
export type PhysicalAsset = {
  id?: string;
  assetName?: string;
  type?: string;
  notes?: string;
  assetTypeId?: string;
};
export type DispatchTicketImage = {
  filename?: string;
  uploadedTime?: string;
};
export type DispatchTicketSchema = {
  id?: string;
  externalId?: number;
  status:
    | "UNASSIGNED"
    | "ASSIGNED"
    | "IN_PROGRESS"
    | "COMPLETED"
    | "PARTIALLY_COMPLETED"
    | "FAILED";
  type:
    | "DROP_OFF"
    | "PICK_UP"
    | "EXCHANGE"
    | "LIVE_LOAD"
    | "PICK_AND_RETURN"
    | "DELIVERY";
  customerId: string;
  customer?: {
    id: string;
    displayName: string;
  };
  driverId?: string;
  driver?: {
    id: string;
    name: string;
    carrierId?: string;
  };
  contactId?: string;
  contact?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    firstNameLegal?: string;
    lastNameLegal?: string;
    phone1?: string;
    phone2?: string;
    email?: string;
    notes?: string;
  };
  createdAt?: string;
  updatedAt?: string;
  scheduleDate?: string;
  scheduleTimeActive?: boolean;
  requestDate?: string;
  startTime?: string;
  completionTime?: string;
  mileage?: string;
  yardId?: string;
  yard?: {
    id: string;
    name: string;
    locationId: string;
  };
  docs?: {
    name: string;
    url: string;
    uuid: string;
    createdAt: string;
  }[];
  uploadcareGroupId?: string;
  locationId?: string;
  location?: {
    id: string;
    name: string;
  };
  dispatchTicketAssets?: {
    id?: string;
    status?: "DEPLOYED" | "IN_PROGRESS" | "INVENTORY" | "FAILED";
    fromLocationId?: string;
    fromLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    toLocationId?: string;
    toLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    currentLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    dispatchTicketId?: string;
    assetId?: string;
    asset?: any;
    note?: string;
    completionNote?: string;
    dispatcherCompletionNote?: string;
    createdAt?: string;
    effectiveDate?: string;
  }[];
  note?: string;
  loadBoardIndex?: number;
  interYard?: {
    startLocationId: string;
    startLocationName?: string;
    endLocationId: string;
    endLocationName?: string;
  };
  yardDepartureDate?: string;
  yardArrivalDate?: string;
  yardReturnArrivalDate?: string;
  yardReturnDepartureDate?: string;
  customerDepartureDate?: string;
  customerArrivalDate?: string;
  customerReturnArrivalDate?: string;
  customerReturnDepartureDate?: string;
  images?: DispatchTicketImage[];
  signature?: string;
  requestNotes?: string;
  requestedScheduleDate?: string;
  recurringDispatchTicketId?: string;
  dispatcherCompletionNotes?: string;
  driverCompletionNotes?: string;
  hash?: string;
  intercompany?: boolean;
};
export type CreateDispatchTicketBody = {
  status:
    | "UNASSIGNED"
    | "ASSIGNED"
    | "IN_PROGRESS"
    | "COMPLETED"
    | "PARTIALLY_COMPLETED"
    | "FAILED";
  type:
    | "DROP_OFF"
    | "PICK_UP"
    | "EXCHANGE"
    | "LIVE_LOAD"
    | "PICK_AND_RETURN"
    | "DELIVERY";
  customerId: string;
  driverId?: string;
  scheduleDate?: string;
  scheduleTimeActive?: boolean;
  requestDate?: string;
  startTime?: string;
  completionTime?: string;
  mileage?: string;
  yardId?: string;
  docs?: {
    name: string;
    url: string;
    uuid: string;
    createdAt: string;
  }[];
  uploadcareGroupId?: string;
  locationId?: string;
  dispatchTicketAssets?: {
    id?: string;
    status?: "DEPLOYED" | "IN_PROGRESS" | "INVENTORY" | "FAILED";
    fromLocationId?: string;
    fromLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    toLocationId?: string;
    toLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    currentLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    dispatchTicketId?: string;
    assetId?: string;
    asset?: any;
    note?: string;
    completionNote?: string;
    createdAt?: string;
  }[];
  note?: string;
  interYard?: {
    startLocationId: string;
    startLocationName?: string;
    endLocationId: string;
    endLocationName?: string;
  };
  intercompany?: boolean;
  idempotencyKey: string;
};
export type PatchDispatchTicketBody = {
  id?: string;
  status?:
    | "UNASSIGNED"
    | "ASSIGNED"
    | "IN_PROGRESS"
    | "COMPLETED"
    | "PARTIALLY_COMPLETED"
    | "FAILED";
  startTime?: string;
  completionTime?: string;
  scheduleDate?: string;
  scheduleTimeActive?: boolean;
  loadBoardIndex?: number;
  driverId?: string;
  inboundTicketId?: string;
  outboundTicketId?: string;
  hash?: string;
  intercompany?: boolean;
};
export type UpdateDispatchTicketBody = {
  status:
    | "UNASSIGNED"
    | "ASSIGNED"
    | "IN_PROGRESS"
    | "COMPLETED"
    | "PARTIALLY_COMPLETED"
    | "FAILED";
  type?:
    | "DROP_OFF"
    | "PICK_UP"
    | "EXCHANGE"
    | "LIVE_LOAD"
    | "PICK_AND_RETURN"
    | "DELIVERY";
  customerId?: string;
  driverId?: string;
  scheduleDate?: string;
  scheduleTimeActive?: boolean;
  requestDate?: string;
  startTime?: string;
  completionTime?: string;
  yardId?: string;
  docs?: {
    name: string;
    url: string;
    uuid: string;
    createdAt: string;
  }[];
  uploadcareGroupId?: string;
  locationId?: string;
  dispatchTicketAssets?: {
    id?: string;
    status?: "DEPLOYED" | "IN_PROGRESS" | "INVENTORY" | "FAILED";
    fromLocationId?: string;
    fromLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    toLocationId?: string;
    toLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    currentLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    dispatchTicketId?: string;
    assetId?: string;
    asset?: any;
    note?: string;
    completionNote?: string;
    dispatcherCompletionNote?: string;
    createdAt?: string;
    effectiveDate?: string;
  }[];
  note?: string;
  interYard?: {
    startLocationId: string;
    startLocationName?: string;
    endLocationId: string;
    endLocationName?: string;
  };
  mileage?: string;
  loadBoardIndex?: number;
  yardDepartureDate?: string;
  yardArrivalDate?: string;
  yardReturnArrivalDate?: string;
  yardReturnDepartureDate?: string;
  customerDepartureDate?: string;
  customerArrivalDate?: string;
  customerReturnArrivalDate?: string;
  customerReturnDepartureDate?: string;
  images?: DispatchTicketImage[];
  inboundTicketId?: string | null;
  requestNotes?: string;
  requestedScheduleDate?: string;
  hash?: string;
  intercompany?: boolean;
};
export type VoidDispatchTicketBody = {
  id?: string;
  status?:
    | "UNASSIGNED"
    | "ASSIGNED"
    | "IN_PROGRESS"
    | "COMPLETED"
    | "PARTIALLY_COMPLETED"
    | "FAILED";
  startTime?: string;
  completionTime?: string;
  scheduleDate?: string;
  scheduleTimeActive?: boolean;
  loadBoardIndex?: number;
  driverId?: string;
  inboundTicketId?: string | null;
  dispatchTicketAssets?: {
    id?: string;
    status?: "DEPLOYED" | "IN_PROGRESS" | "INVENTORY" | "FAILED";
    fromLocationId?: string;
    fromLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    toLocationId?: string;
    toLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    currentLocation?: {
      id?: string;
      name?: string;
      customerId?: string;
      customer?: {
        id?: string;
        displayName?: string;
      };
    };
    dispatchTicketId?: string;
    assetId?: string;
    asset?: any;
    note?: string;
    completionNote?: string;
    createdAt?: string;
  }[];
  requestNotes?: string;
  requestedScheduleDate?: string;
  hash?: string;
  intercompany?: boolean;
};
export type RecurrenceRuleSchema = {
  frequency?: "YEARLY" | "MONTHLY" | "WEEKLY" | "DAILY";
  interval?: number;
  dayOfTheWeek?: "MO" | "TU" | "WE" | "TH" | "FR" | "SA" | "SU";
};
export type RecurringDispatchTicketSchema = {
  yardId?: string;
  scheduleDate?: string;
  scheduledTimeActive?: boolean;
  type?:
    | "DROP_OFF"
    | "PICK_UP"
    | "EXCHANGE"
    | "LIVE_LOAD"
    | "PICK_AND_RETURN"
    | "DELIVERY";
  customerId?: string;
  contactId?: string;
  locationId?: string;
  driverId?: string;
  includeDriver?: boolean;
  interYardStartLocationId?: string;
  interYardEndLocationId?: string;
  endDate?: string;
  note?: string;
  recurrenceRule?: RecurrenceRuleSchema;
  dispatchTicket?: CreateDispatchTicketBody;
};
export type DriverResponseBody = {
  name?: string;
  isActive?: boolean;
  organizationId?: string;
  truckId?: string | null;
  trailerId?: string | null;
  id: string;
  truck?: AssetResponseSchema;
  trailer?: AssetResponseSchema;
  createdAt?: string;
  updatedAt?: string;
  archivedAt?: string;
  gsUserId?: string;
  carrierId?: string;
};
export type CreateDriverBody = {
  name?: string;
  isActive?: boolean;
  organizationId?: string;
  truckId?: string | null;
  trailerId?: string | null;
  carrierId?: string;
};
export type UpdateDriverBody = {
  name?: string;
  isActive?: boolean;
  organizationId?: string;
  truckId?: string | null;
  trailerId?: string | null;
  id: string;
  carrierId?: string;
};
export const {
  useGetAccountsQuery,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useCreateAccountTransferMutation,
  useGetCommoditiesQuery,
  useCreateCommodityMutation,
  usePutCommodityMutation,
  useGetCsvQuery,
  usePostCsvMutation,
  useGetPriceSheetCsvMultiQuery,
  usePutPriceSheetCsvMultiMutation,
  useGetPriceSheetCsv2Query,
  usePutPriceSheetCsv2Mutation,
  useGetCommodityQuery,
  useUpdateCommodityMutation,
  useGetCustomersQuery,
  useCreateCustomerMutation,
  useGetCustomerInvoicesQuery,
  useGetCustomerQuery,
  useUpdateCustomerMutation,
  usePatchCustomerMutation,
  useArchiveCustomerMutation,
  useDeleteCustomerLocationMutation,
  useCheckBuyEligibilityMutation,
  useGetGsUserListQuery,
  useCreateGsUserMutation,
  useGetGsUserQuery,
  useUpdateGsUserMutation,
  useResetGsUserPasswordMutation,
  useGetTexasCashCardQuery,
  useCreateTexasCashCardMutation,
  useInviteContactToPortalMutation,
  useGetSupplierTypesQuery,
  useCreateSupplierTypeMutation,
  usePatchSupplierTypeMutation,
  useGetVendorClassesQuery,
  useCreateVendorClassMutation,
  usePatchVendorClassMutation,
  useGetCustomerMaterialPurchasePriceHistoryQuery,
  useGetFinishedGoodsQuery,
  useCreateFinishedGoodMutation,
  useGetFinishedGoodByIdQuery,
  useUpdateFinishedGoodMutation,
  useVoidFinishedGoodMutation,
  useGetFinishedGoodByTagQuery,
  useGetInboundTicketsQuery,
  useCreateInboundTicketMutation,
  useGetInboundTicketsByIdsMutation,
  useGetInboundTicketNotesQuery,
  useUpdateInboundTicketNotesMutation,
  useCreateInboundTicketNoteMutation,
  useDeleteInboundTicketNoteMutation,
  useGetInboundTicketQuery,
  useUpdateInboundTicketMutation,
  useVoidInboundTicketMutation,
  useGetInboundTicketQueuePaymentsQuery,
  useGetTexasXmlUploadFileQuery,
  useGetMaterialTypesQuery,
  useCreateMaterialTypeMutation,
  useGetMaterialTypeQuery,
  usePatchMaterialTypeMutation,
  useArchiveMaterialTypeMutation,
  useGetMaterialsQuery,
  useCreateMaterialMutation,
  useGetMaterialQuery,
  useUpdateMaterialMutation,
  useGetOutboundTicketQuery,
  useUpdateOutboundTicketMutation,
  useVoidOutboundTicketMutation,
  useGetOutboundTicketsQuery,
  useCreateOutboundTicketMutation,
  useGetOutboundTicketsByIdsMutation,
  useGetPackingListsQuery,
  useCreatePackingListMutation,
  useGetPackingListByIdQuery,
  useUpdatePackingListMutation,
  useVoidPackingListMutation,
  useGetInventoryAdjustmentsQuery,
  useCreateInventoryAdjustmentMutation,
  useGetInventoryAdjustmentQuery,
  useUpdateInventoryAdjustmentMutation,
  useDeleteInventoryAdjustmentMutation,
  useGetPriceSheetsQuery,
  useCreatePriceSheetMutation,
  useGetDefaultPriceSheetQuery,
  useGetPriceSheetQuery,
  useUpdatePriceSheetMutation,
  useArchivePriceSheetMutation,
  useDeletePriceEntryMutation,
  useGetPriceSheetCsvQuery,
  useUploadNewPriceSheetsMutation,
  useUploadUpdatePriceSheetsMutation,
  useMergeInboundTicketsMutation,
  useGetRegradesQuery,
  useCreateRegradeMutation,
  useGetRegradeByIdQuery,
  useUpdateRegradeMutation,
  useVoidRegradeMutation,
  useGetInventoryCommodityHandlerQuery,
  useGetInventoryByCommodityQuery,
  useGetInventoryFinishedGoodListQuery,
  useGetInventoryRegradeMetaQuery,
  useGetInventoryPackingListMetaQuery,
  useGetInventoryMaterialTypeQuery,
  useGetInventoryMaterialTypeByIdsMutation,
  useGetNegativeInventoryListQuery,
  useGetOrganizationQuery,
  useGetBenchmarksQuery,
  useCreateBenchmarkMutation,
  useGetBenchmarkByIdQuery,
  useUpdateBenchmarkMutation,
  useGetPriceEntriesQuery,
  useCreatePriceEntryMutation,
  useGetPriceEntryQuery,
  useUpdatePriceEntryMutation,
  useGetPriceEntryHistoryByMaterialIdQuery,
  useGetSalesOrdersQuery,
  useCreateSalesOrderMutation,
  useGetSalesOrderQuery,
  useUpdateSalesOrderMutation,
  useArchiveSalesOrderMutation,
  useGetSalesOrdersCsvQuery,
  useUploadSalesOrdersCsvMutation,
  useGetPurchaseOrdersV2Query,
  useGetPurchaseOrdersQuery,
  useCreatePurchaseOrderMutation,
  useArchivePurchaseOrderMutation,
  useGetPurchaseOrderQuery,
  useUpdatePurchaseOrderMutation,
  useGetPurchaseOrdersCsvQuery,
  useUploadPurchaseOrdersCsvMutation,
  useDeleteInvoiceBulkPaymentMutation,
  useCreateInvoiceBulkPaymentMutation,
  useGetInvoicePaymentsQuery,
  useGetInvoicesV2Query,
  useCreateInvoiceV2Mutation,
  useCreateInboundInvoiceV2Mutation,
  useUpdateInboundInvoiceV2Mutation,
  useGetInvoicePaymentQuery,
  useGetInvoiceV2Query,
  useUpdateInvoiceV2Mutation,
  useGetInvoiceV3Query,
  useVoidInvoiceMutation,
  useGetDevicesQuery,
  useCaptureImageMutation,
  useCreateQzTraySignatureMutation,
  useGetOrgImageQuery,
  useUploadOrgImageMutation,
  useGetBillsQuery,
  useGetBillQuery,
  useUpdateBillMutation,
  useMergeBillMutation,
  useUnmergeBillMutation,
  useUpdateAndMergeBillMutation,
  useVoidBillMutation,
  useGetPaymentsQuery,
  useCreatePaymentMutation,
  useGetPaymentQuery,
  useUpdatePaymentMutation,
  useVoidPaymentMutation,
  useGetItemsToSyncQuery,
  useSyncItemsMutation,
  useGetBatchesQuery,
  useGetBatchQuery,
  useMarkItemsAsCompletedMutation,
  useSendEmailMutation,
  useSendOutboundTicketEmailMutation,
  useGetPermissionsQuery,
  useGetLicenseInfoMutation,
  useGetVehicleInfoFromVinQuery,
  useGetPullApartScrapRowsQuery,
  useGetInvoicePaymentByInvoiceIdQuery,
  useCreateInvoicePaymentMutation,
  useGetYardQuery,
  useGetSettingsQuery,
  usePostSettingsRbacMutation,
  useGetFpSettingsQuery,
  useCreateFeeOrPromotionPresetMutation,
  useUpdateFeeOrPromotionPresetMutation,
  useArchiveFeeOrPromotionPresetMutation,
  useUpdateSettingsMutation,
  useGetTransfersQuery,
  useGetTransferQuery,
  useGetScaleReadingQuery,
  useCreateVehicleMutation,
  useGetVehiclesQuery,
  useGetVehicleQuery,
  useUpdateVehicleMutation,
  useSaveGsPayVendorMutation,
  useGetFreightBillsQuery,
  useGetBatchBillsQuery,
  useCreateBatchBillMutation,
  useGetBatchBillQuery,
  useUpdateBatchBillMutation,
  usePayBatchBillMutation,
  useGetVehicleMakeModelsQuery,
  useGetCurrencyConversionsQuery,
  useUpdateCurrencyConversionsMutation,
  useGetLockAccountingPeriodQuery,
  useUpdateLockAccountingPeriodMutation,
  useGetLockedEntitiesQuery,
  useGetFreightLanesQuery,
  useCreateFreightLaneMutation,
  useGetFreightLaneQuery,
  useUpdateFreightLaneMutation,
  useGetFreightLaneLocationsQuery,
  useCreateFreightLaneLocationMutation,
  useUpdateFreightLaneLocationMutation,
  useGetFreightLanePricesQuery,
  useUpdateFreightLanePricesMutation,
  useGetMetabaseUrlQuery,
  useGetPaymentTermsQuery,
  useCreatePaymentTermMutation,
  usePatchPaymentTermMutation,
  useDeactivatePaymentTermMutation,
  useGetAssetsByCategoryQuery,
  useCreatePhysicalAssetMutation,
  useGetAssetByCategoryAndIdQuery,
  usePatchPhysicalAssetMutation,
  useGetAssetTypesQuery,
  useCreateAssetTypesMutation,
  useUpdateAssetTypesMutation,
  useGetAssetHistoryQuery,
  useCreateAssetStatusMutation,
  useGetDispatchTicketsQuery,
  useCreateDispatchTicketMutation,
  usePatchMultipleDispatchTicketsMutation,
  useGetDispatchTicketQuery,
  useUpdateDispatchTicketMutation,
  usePatchDispatchTicketMutation,
  useVoidDispatchTicketMutation,
  useGetRecurringDispatchTicketsQuery,
  useCreateRecurringDispatchTicketMutation,
  useGetRecurringDispatchTicketQuery,
  useUpdateRecurringDispatchTicketMutation,
  useArchiveRecurringDispatchTicketMutation,
  useGetDriversQuery,
  useCreateDriverMutation,
  useGetDriverByIdQuery,
  useUpdateDriverMutation,
  useArchiveDriverMutation,
  useValidateAddressesMutation,
} = injectedRtkApi;
